webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52Ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bh4A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HgIx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4cd6ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("52Ql")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56463f7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.link))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("Bh4A")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-56463f7a"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5139845f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("HgIx")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b54d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tGyY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Escrime XXI N⁰. 120",
  "shortTitle": "",
  "description": "",
  "width": 1173,
  "height": 880,
  "currentLanguage": "FR",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://escrime-xxi.fie.org/120/en/"
  }, {
    code: "FR",
    text: "French",
    href: "https://escrime-xxi.fie.org/120/fr/"
  }, {
    code: "ES",
    text: "Spanish",
    href: "https://escrime-xxi.fie.org/120/es/"
  }],
  "basePath": "/120/fr",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://escrime-xxi.fie.org/120/fr/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '/120/fr/static/_content/escrime-120-fr.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": true,
    "guideEnabled": false
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 1-title\" style=\"top:84px;left:52px;\" src=\"/120/fr/static/_content/1-title-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:210px;left:52px;\" src=\"/120/fr/static/_content/1-title-2.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:1px;left:290px;\" src=\"/120/fr/static/_content/1-numerals-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:84px;left:824px;\" src=\"/120/fr/static/_content/1-ed-1.png\">\n        <!-- <img class=\"abs halfScale 1-title\" style=\"top:84px;left:957px;\" src=\"/120/fr/static/_content/logo.png\"> -->\n        <img class=\"abs halfScale 1-title\" style=\"top:329px;left:52px;\" src=\"/120/fr/static/_content/1-sub-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:433px;left:53px;\" src=\"/120/fr/static/_content/1-sub-2.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:499px;left:54px;\" src=\"/120/fr/static/_content/1-sub-3.png\">\n        <img id=\"1-arrow\" class=\"halfScale pointer\" style=\"top:756px;right:-70px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/1-arrow.png\">\n      ",
    "mobileHtml": "\n        <img src=\"/120/fr/static/_content/1-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n            .staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(idOf(\"1-arrow\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n      \n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "N˚120 MAGAZINE NUMÉRIQUE  FÉDÉRATION INTERNATIONALE D’ESCRIME  Championnats du monde Juniors et Cadets Coupe du Monde Grand Prix  Utilisez les flèches de votre clavier ou balayez l’écran avec le doigt pour naviguer horizontalement dans le magazine"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 2-title\" style=\"top:79px;left:60px;\" src=\"/120/fr/static/_content/2-title-1.png\">\n        <img class=\"abs halfScale pointer howto-desktop\" style=\"top:96px;left:819px;\" onclick=\"switchPopHowto(true)\"\n          src=\"/120/fr/static/_content/2-btn-1.png\">\n        <img class=\"abs halfScale pointer howto-ipad\" style=\"top:96px;left:973px;opacity:0\" onclick=\"switchPopHowto(false)\"\n          src=\"/120/fr/static/_content/2-ipad-btn.png\">\n        <img class=\"abs halfScale 2-img howto-desktop\" style=\"top:202px;left:64px;\" src=\"/120/fr/static/_content/2-img-1.png\">\n        <img class=\"abs halfScale 2-img howto-ipad\" style=\"top:191px;left:64px; opacity:0\" src=\"/120/fr/static/_content/2-ipad.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:607px;left:14px;\" src=\"/120/fr/static/_content/2-text-1.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:597px;left:226px;\" src=\"/120/fr/static/_content/2-text-2.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:597px;left:496px;\" src=\"/120/fr/static/_content/2-text-3.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:597px;left:796px;\" src=\"/120/fr/static/_content/2-text-4.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim\n            .staggerFromTo(cOf(\"2-text\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1)\n        }\n\n        function switchPopHowto(bool){\n          if(bool){\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-ipad\")[0].style.opacity = 0;\n              cOf(\"howto-ipad\")[1].style.display = \"none\";\n            }});\n            cOf(\"howto-desktop\")[0].style.opacity = 1;\n            cOf(\"howto-desktop\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:1});\n          }else{\n            cOf(\"howto-ipad\")[0].style.opacity = 1;\n            cOf(\"howto-ipad\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:1});\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-desktop\")[0].style.opacity = 0;\n              cOf(\"howto-desktop\")[1].style.display = \"none\";\n            }});\n          }\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          resetNumbers(\"2-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "C OMMENT NAVIGUER  Cliquez pour changer d’affichage  COMMENT NAVIGUER Escrime XXI Le magazine de l’escrime utilise les toutes dernières technologies numériques. Voici quelques-unes de ses caractéristiques les plus séduisantes.  IPAD  BUREAU  SP ORT  COUPE DU MONDE DE SABRE MASCULIN : UN DOUBLÉ EN OR POUR LA HONGRIE À BUDAPEST BUDAPEST, HONGRIE 4–6 MARS 2022  NAVIGATION Utilisez les flèches de votre pavé numérique pour vous déplacer horizontalement à travers le magazine.  Navigation Pour voir le magazine, utilisez les flèches de votre pavé numérique pour naviguer horizontalement.  BROWSER Pour de meilleurs résultats, nous recommandons d’utiliser les navigateurs Safari ou Google Chrome.  EXPLOREZ  térieur ! Des articles passionnants à l’in  1 2 3 FENÊTRES CONTEXTUELLES  BOUTON DE LECTURE  MÉDIAS SOCIAUX  NOMBRES  Appuyez pour faire surgir des trésors d’information.  Ce magazine propose de superbes vidéos, que l’on peut voir en appuyant sur ce bouton.  Appuyez sur les icones des réseaux sociaux que vous rencontrerez tout au long du magazine.  Appuyez sur les boutons pour dévoiler plus de contenus passionnants.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.absolutefencinggear.com/\" target=\"_blank\" class=\"contentLinkNone\" style=\"    top: 720px; left: 430px; width: 710px; height: 60px;\"></a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.absolutefencinggear.com/\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/3-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 4-title\" style=\"top:47px;left:63px;\" src=\"/120/fr/static/_content/4-title-1.png\">\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC abs halfpulse animatedpulse\" style=\"top: 47px; left:644px;\" src=\"/120/fr/static/_content/fb-navy.png\">\n        </a>\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC abs halfpulse animatedpulse\" style=\"top: 86px; left:644px;\" src=\"/120/fr/static/_content/tw-navy.png\">\n        </a>\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n        <img id=\"4-next\" class=\"halfScale pointer\" style=\"top:719px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-sky.png\">\n\n          <img class=\"cont-item cont-item-1-btn halfScale\" style=\"top:251px;left:439px;opacity:0;\"\n              src=\"/120/fr/static/_content/4-popup-1-1.png\">\n          <img class=\"cont-item cont-item-2-btn halfScale\" style=\"top:259px;left:440px;opacity:0\"\n            src=\"/120/fr/static/_content/4-popup-2-1.png\">\n          <img class=\"cont-item cont-item-3-btn halfScale\" style=\"top:259px;left:440px;opacity:0\"\n            src=\"/120/fr/static/_content/4-popup-2-2.png\">\n          <img class=\"cont-item cont-item-4-btn halfScale\" style=\"top:204px;left:440px;opacity:0\"\n            src=\"/120/fr/static/_content/4-popup-3-1.png\">\n          <img class=\"cont-item cont-item-5-btn halfScale\" style=\"top:269px;left:440px;opacity:0\"\n            src=\"/120/fr/static/_content/4-popup-4-1.png\">\n          <img class=\"cont-item cont-item-6-btn halfScale\" style=\"top:204px;left:440px;opacity:0\"\n            src=\"/120/fr/static/_content/4-popup-5-1.png\">\n          <img class=\"cont-item cont-item-7-btn halfScale\" style=\"top:251px;left:440px;opacity:0\"\n            src=\"/120/fr/static/_content/4-popup-6-1.png\">\n          \n          <div class=\"addContentLink\" onclick=\"contentsBub(1);\" style=\"top: 275px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(2);\" style=\"top: 345px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"contentLinkNone 2-click\" onclick=\"contentsBub(2);\"\n          style=\"top: 715px; left: 496px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 3-click\" onclick=\"contentsBub(2);\"\n          style=\"top: 715px; left: 496px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 2-click\" onclick=\"contentsBub(3);\"\n            style=\"top: 715px; left: 688px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 3-click\" onclick=\"contentsBub(3);\"\n            style=\"top: 715px; left: 688px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(4);\" style=\"top: 415px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(5);\" style=\"top: 486px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(6);\" style=\"top: 556px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(7);\" style=\"top: 626px; left: 65px; width: 377px; height: 50px;\"></div>\n          \n          <div class=\"contentLink cont-item-1-link\" onclick=\"Publish.goToPage(6)\"\n            style=\"top: 273px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(8)\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(10)\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(14)\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(17)\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(20)\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(22)\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(25)\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(27)\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(31)\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(33)\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(35)\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(39)\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(45)\"\n            style=\"top: 415px; left: 442px; width: 590px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-5-link\"\n            onclick=\"Publish.goToPage(47)\"\n            style=\"top: 486px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-1'), 1000})\"\n            style=\"top: 556px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-2'), 1000})\"\n            style=\"top: 626px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-1', '53-cta-1'), 1000})\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-2', '53-cta-2'), 1000})\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-3', '53-cta-3'), 1000})\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-4', '53-cta-4'), 1000})\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-5', '53-cta-5'), 1000})\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-6', '53-cta-6'), 1000})\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim\n            .fromTo(cOf(\"4-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"4-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function contentsBub(index){\n          console.log(index)\n          for(var i=0; i <= 9; i++){\n            if(i == index){\n              [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                c.style.display = \"\";\n              },0);\n              [].slice.call(cOf(i+\"-click\")).reduce(function(p,c){\n                c.style.display = \"\";\n              },0);\n              TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0, {opacity:1, onComplete:function(){\n                \n                cOf(\"cont-item-\"+index+\"-link\")[0].style.display = \"\"\n                if(cOf(\"cont-item-\"+index+\"-link\")[1]){\n                  cOf(\"cont-item-\"+index+\"-link\")[1].style.display = \"\" \n                }\n              }});\n            }else{\n              [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                  c.style.display = \"none\";\n                },0);\n              [].slice.call(cOf(i+\"-click\")).reduce(function(p,c){\n                  c.style.display = \"none\";\n                },0);\n              TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0, {opacity:0});\n            }\n          }\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          resetNumbers(\"4-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SOMMAIRE  DANS CE NUMÉRO  Bienvenue dans la dernière édition d’Escrime XXI, proposant les meilleures images, vidéos et articles sur l’escrime, le tout dans une éblouissante nouvelle maquette.  WWW.FIE.ORG  ÉDITORIAL  SPORT  Cliquez pour faire apparaître les détails  ACTUALITÉS DE LA FIE ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONAL  N˚120 MAGAZINE NUMÉRIQUE  FÉDÉRATION INTERNATIONALE D’ESCRIME  ACTUALITÉS INTERNATIONALES  Championnats du monde Juniors et Cadets Coupe du Monde Grand Prix  NÉCROLOGIES Utilisez les flèches de votre clavier ou balayez l’écran avec le doigt pour naviguer horizontalement dans le magazine  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:info@fie.ch\">\n          <div class=\"contentLink\" style=\"bottom: 162px; right: 526px; width: 124px; height: 21px;\"></div>\n        </a>\n        <a href=\"http://www.touchline.com\" target=\"_blank\">\n          <div class=\"contentLink\" style=\"bottom: 120px; right: 236px; width: 234px; height: 21px;\"></div>\n        </a>\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLink\" style=\"bottom: 140px; right: 568px; width: 82px; height: 21px;\"></div>\n        </a>\n\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:785px;left:41px\"\n            src=\"/120/fr/static/_content/tw-white.png\">\n        </a>\n\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:785px;left:94px\"\n            src=\"/120/fr/static/_content/fb-white.png\">\n        </a>\n\n        <a href=\"https://www.youtube.com/user/FIEvideo\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:785px;left:147px\"\n            src=\"/120/fr/static/_content/yt-white.png\">\n        </a>\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <img id=\"5-next\" class=\"halfScale pointer\" style=\"top:653px;right:-80px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-sky.png\">\n      ",
    "mobileHtml": "\n        <p><strong>Pr\xE9sident par interim : </strong><br> Emmanuel Katsiadakis (M.H.) (GRE)\n          <br><strong>Secr\xE9taire Tr\xE9sorier : </strong><br> Ferial Nadira Salhi (ALG)\n        </p>\n        <p><strong>Vice-Pr\xE9sidents : </strong><br>Erika Aze (LAT)<br>Ana Irene Delgado Guerra (PAN)<br>Abdelmoneim Elhamy El Husseiny (EGY)</p>\n        <p><strong>Membres : </strong><br>Rusni Abu Hassan (MAS)<br>Donald Anthony Jr. (USA)<br>Paolo Azzi (ITA)<br>Bruno Gares (FRA)<br>Vadym Guttsait (UKR)<br>Velichka Hristeva (BUL)<br>Yuki Ota (JPN)<br>Novak Perovic (RSA)<br>Oleg Peskov (KAZ)<br>Haibin Wang (CHN)<br>Aldo Montano President of the FIE Athletes\u2019 Commission (ITA)</p>\n        <p><strong>Pr\xE9sident de la Conf\xE9d\xE9ration Africaine d\u2019Escrime : </strong><br> Mbagnick Ndiaye (SEN) <br><strong>Pr\xE9sident de la Conf\xE9d\xE9ration Panam\xE9ricaine d\u2019Escrime : </strong><br> Vitaly Logvin (MEX) <br><strong>Pr\xE9sident de la Conf\xE9d\xE9ration Asiatique d\u2019Escrime : </strong><br> HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE)<br><strong>Pr\xE9sident de la Conf\xE9d\xE9ration Europ\xE9enne d\u2019Escrime : </strong><br> Stanislav Pozdnyakov (RUS)\n          <br><strong>Pr\xE9sident de la Conf\xE9d\xE9ration Oc\xE9anique d\u2019Escrime : </strong><br>  Helen Smith (M.H.) (AUS)\n        </p>\n        <h2 id=\"fie-head-office\">Si\xE8ge de la FIE </h2>\n        <p><strong>Directrice g\xE9n\xE9rale : </strong><br>Nathalie Rodriguez M.-H. (FRA)\n        </p>\n        <h2 id=\"administration\">Administration</h2>\n        <p><strong>Directrice administrative : </strong><br> Elena Murdaca (ITA)<br><strong>Directrice de la comptabilit\xE9 : </strong><br> Sandra Baroni (SUI)<br><strong>Assistante administrative : </strong><br> Ylenia Murdaca (ITA)<br><strong>Chef de projet : </strong><br> Ekaterina Mashina (RUS)</p>\n        <h2 id=\"sport\">Sport</h2>\n        <p><strong>Directeur sport et technique : </strong><br>  Evgeny Tsoukhlo (RUS)<br><strong>Manager de la technologie et de l\u2019administration du sport : </strong><br> Natalia Bodrova (RUS)<br><strong>Cheffe des op\xE8rations : </strong><br>  Elena Huot (RUS)</p>\n        <h2 id=\"communication-marketing-tv\">Communication, Marketing, TV</h2>\n        <p><strong>Chef du cabinet du Pr\xE9sident : </strong><br>Nina Lalovic (SRB)<br><strong>Manager digital et communication : </strong><br> Maria Ntanou (GRE)<br><strong>Responsable de la production t\xE9l\xE9visuelle de la FIE : </strong><br> Barna Heder (HUN) <br><strong>Assistante du responsable de la production t\xE9l\xE9visuelle de la FIE : </strong><br>  Svetlana Krasnokoutskaya (RUS)<br><strong>Attach\xE9 de presse : </strong><br> Serge Timacheff (USA)<br><strong>Photographie : </strong><br> Augusto Bizzi (ITA)</p>\n        <h2 id=\"design\">Design  </h2>\n        <p>Touchline (www.touchline.com)</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim\n            .fromTo(idOf(\"5-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          resetNumbers(\"5-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "C OMITÉ E XÉCUTIF DE L A FIE  SIÈGE DE LA FIE Directrice générale Nathalie Rodriguez M.-H. (FRA)  Président par interim : Emmanuel Katsiadakis (M.H.) (GRE) Secrétaire Trésorier : Ferial Nadira Salhi (ALG) Vice-Présidents :  Erika Aze (LAT) Ana Irene Delgado Guerra (PAN) Abdelmoneim Elhamy El Husseiny (EGY) Membres :  Rusni Abu Hassan (MAS) Donald Anthony Jr. (USA) Paolo Azzi (ITA) Bruno Gares (FRA) Vadym Guttsait (UKR) Velichka Hristeva (BUL) Yuki Ota (JPN) Novak Perovic (RSA) Oleg Peskov (KAZ) Haibin Wang (CHN) Aldo Montano President of the FIE athletes’ commission (ITA) Président de la Confédération Africaine d’Escrime : Mbagnick Ndiaye (SEN) Président de la Confédération Panaméricaine d’Escrime : Vitaly Logvin (MEX) Président de la Confédération Asiatique d’Escrime : HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE) Président de la Confédération Européenne d’Escrime : Stanislav Pozdnyakov (RUS) Président de la Confédération Océanique d’Escrime : Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tél. : +41 21 320 31 15 Fax : +41 21 320 31 16 e-mail : info@fie.ch www.fie.org  Administration Directrice administrative : Elena Murdaca (ITA) Directrice de la comptabilité : Sandra Baroni (SUI) Assistante administrative : Ylenia Murdaca (ITA) Chef de projet : Ekaterina Mashina (RUS) Sport Directeur sport et technique : Evgeny Tsoukhlo (RUS) Manager de la technologie et de l’administration du sport : Natalia Bodrova (RUS) Cheffe des opèrations : Elena Huot (RUS) Communication, Marketing, TV Chef du cabinet du Président : Nina Lalovic (SRB) Manager digital et communication : Maria Ntanou (GRE) Responsable de la production télévisuelle de la FIE : Barna Heder (HUN) Assistante du responsable de la production télévisuelle de la FIE : Svetlana Krasnokoutskaya (RUS) Attaché de presse : Serge Timacheff (USA) Photographie : Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img id=\"6-img\" class=\"halfScale 6-text-1 6-text\" style=\"top:145px;left:367px\"\n          src=\"/120/fr/static/_content/6-img-1.png\">\n        <img id=\"6-title\" class=\"halfScale 6-title 6-text-1 6-text\" style=\"top:629px;left:185px\"\n          src=\"/120/fr/static/_content/6-title-1.png\">\n        \n        <img id=\"6-text-1\" class=\"halfScale 6-text-1 6-text\" style=\"top:143px;left:602px\"\n          src=\"/120/fr/static/_content/6-text-1.png\">\n        <img id=\"6-text-2\" class=\"halfScale 6-text-2 6-text\" style=\"top:143px;left:155px; opacity:0;\"\n          src=\"/120/fr/static/_content/6-text-2.png\">\n        \n        <img id=\"6-cta-1\" class=\"halfScale pointer 6-btn\" style=\"top: 697px; left: 599px;transform: scale(0.505);\"\n          onclick=\"toggleText6(false);\" src=\"/120/fr/static/_content/6-btn-1.png\">\n        <img id=\"6-cta-2\" class=\"halfScale pointer 6-btn\" style=\"top: 697px; left: 813px;transform: scale(0.505);opacity:0\"\n          onclick=\"toggleText6(true);\" src=\"/120/fr/static/_content/6-btn-2.png\">\n\n        <img id=\"6-next\" class=\"halfScale pointer\" style=\"top:719px;right:-80px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-navy.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <h2 id=\"together-we-are-fencing\">Ensemble, nous sommes l\u2019escrime</h2>\n        <img src=\"/120/fr/static/_content/6-mobile-1.jpg\">\n        <p>  <strong>Chers amis,</strong></p>\n        <p>Nous sommes heureux de vous pr\xE9senter cette \xE9dition d\u2019Escrime, consacr\xE9e \xE0 un monde de l\u2019escrime qui est, une fois encore, menac\xE9 \xE0 l\u2019\xE9chelle mondiale. En ces temps extr\xEAmement difficiles, la FIE exprime le souhait que la paix r\xE8gne de nouveau dans le monde, et nous devons, en tant que famille mondiale, faire preuve de solidarit\xE9 pour aider ceux qui en ont le plus besoin. Le sport est un outil puissant en faveur de la paix, de la r\xE9conciliation et de la compr\xE9hension pour unir les gens. Nous pouvons et devons vivre pacifiquement. \n        </p>\n        <p>Nous avons \xE9galement d\xFB faire face \xE0 la pand\xE9mie mondiale au cours des deux derni\xE8res ann\xE9es. Pendant cette p\xE9riode, la FIE et ses f\xE9d\xE9rations internationales ont travaill\xE9 pour que nos comp\xE9titions puissent se d\xE9rouler en assurant un niveau de s\xE9curit\xE9 le plus \xE9lev\xE9 possible. Les tournois du Grand Prix et de la Coupe du monde ont ainsi repris avec succ\xE8s, et se poursuivront tout au long de l\u2019ann\xE9e, avec encore de nombreuses comp\xE9titions \xE0 venir. Les Championnats du monde d\u2019escrime juniors et cadets 2022 \xE0 Duba\xEF viennent par ailleurs de se terminer. Au total, 1 357 tireurs de 103 pays, soit la participation la plus importante de notre histoire, se sont retrouv\xE9s pour neuf jours de comp\xE9tition pacifiques et passionnants. </p>\n        <p> Les Championnats du monde d\u2019escrime seniors seront ensuite organis\xE9s en \xC9gypte en juillet, et la Croatie accueillera les Championnats du monde d\u2019escrime v\xE9t\xE9rans en octobre. </p>\n        <p>Suite au succ\xE8s retentissant de l\u2019escrime aux Jeux Olympiques de Tokyo 2020, je consid\xE8re que nous sommes dans une position plus forte que jamais pour continuer \xE0 appliquer notre strat\xE9gie afin de d\xE9velopper et d\u2019augmenter encore la popularit\xE9 de notre sport, avec en ligne de mire les prochains Jeux Olympiques de Paris 2024. La croissance remarquable de l\u2019escrime sur les m\xE9dias sociaux, \xE0 la t\xE9l\xE9vision et au niveau de la participation mondiale, montre clairement que nous sommes sur le bon chemin pour d\xE9velopper encore notre sport.</p>\n        <p>Le temps est maintenant venu de nous montrer ing\xE9nieux et innovants pour renforcer l\u2019escrime \xE0 plusieurs niveaux, afin de susciter l\u2019engouement et de mieux faire conna\xEEtre notre sport dans le monde. Nous devons continuer sur la lanc\xE9e des ann\xE9es pass\xE9es pour \xE9voluer encore avec force, enthousiasme et optimisme.  </p>\n        <p>Je vous invite tous \xE0 jouer vos r\xF4les d\u2019ambassadeurs et d\u2019acteurs de notre sport pour devenir encore plus forts et importants, \xE0 la fois dans vos communaut\xE9s et dans vos salles d\u2019escrime. Que vous soyez athl\xE8te, entra\xEEneur, officiel, b\xE9n\xE9vole ou supporter, chacun de vous joue un r\xF4le extr\xEAmement important dans le succ\xE8s de l\u2019escrime mondiale, un r\xF4le qu\u2019on ne soulignera simplement jamais assez. </p><p>Au nom de la FIE, j\u2019aimerais vous remercier de votre soutien constant, et j\u2019esp\xE8re que l\u2019ann\xE9e 2022 vous apporte sant\xE9 et prosp\xE9rit\xE9.</p>\n        <p>Emmanuel Katsiadakis<br><strong>Pr\xE9sident par interim</strong></p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim\n            .fromTo(cOf(\"6-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"6-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function toggleText6(bool){\n          var text1 = idOf(\"6-text-1\");\n          var text2 = idOf(\"6-text-2\");\n          \n          if(!bool && text1.style.opacity == \"0\"){\n            pg6Anim.play();\n            TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:0}, {opacity:1});\n          }else if(bool && text2.style.opacity == \"0\"){\n            pg6Anim.pause();\n            TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:1}, {opacity:0});\n          }\n        }\n\n        function onPageLeave() {\n          toggleText6(false)\n          pg6Anim.stop();\n          resetNumbers(\"6-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ÉDITORIAL  Chers amis, Nous sommes heureux de vous présenter cette édition d’Escrime, consacrée à un monde de l’escrime qui est, une fois encore, menacé à l’échelle mondiale. En ces temps extrêmement difficiles, la FIE exprime le souhait que la paix règne de nouveau dans le monde, et nous devons, en tant que famille mondiale, faire preuve de solidarité pour aider ceux qui en ont le plus besoin. Le sport est un outil puissant en faveur de la paix, de la réconciliation et de la compréhension pour unir les gens. Nous pouvons et devons vivre pacifiquement.  ENSEMBLE, NOUS SOMMES L’ESCRIME  Nous avons également dû faire face à la pandémie mondiale au cours des deux dernières années. Pendant cette période, la FIE et ses fédérations internationales ont travaillé pour que nos compétitions puissent se dérouler en assurant un niveau de sécurité le plus élevé possible. Les tournois du Grand Prix et de la Coupe du monde ont ainsi repris avec succès, et se poursuivront  PAGE 1  PAGE 2  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://shop.pbtfencing.com/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 21px; right: 723px; width: 193px; height: 38px;\"></div>\n        </a>\n        <a href=\"mailto:sales@pbtfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:21px;right:505px;width:205px;height:38px;\"></div>\n        </a>\n        <a href=\"https://www.instagram.com/pbt_fencing\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 21px; right: 259px; width: 236px; height: 38px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://shop.pbtfencing.com/\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/7-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 8-title\" style=\"top:116px;left:65px;\" src=\"/120/fr/static/_content/8-title-1.png\">\n        <img class=\"abs halfScale 8-sub\" style=\"top:364px;left:97px;\" src=\"/120/fr/static/_content/8-sub-1.png\">\n        <img class=\"abs halfScale 8-line\" style=\"top:366px;left:64px;\" src=\"/120/fr/static/_content/8-line-1.png\">\n        <img id=\"8-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"usa-s-gassner-italy-s-cammilletti-win-tashkent-satellite-foil-tournament\">L'Am\xE9ricain Gassner et l'Italienne Cammilletti remportent le tournoi satellite de fleuret de Tachkent  </h2>\n        <img src=\"/120/fr/static/_content/8-mobile-1.jpg\">\n        <p><strong>Tachkent, Ouzb\xE9kistan<br>29 Septembre 2021</strong></p>\n        <p><strong>\u200B\u200BL'Am\xE9ricain Ethan Gassner et l'Italienne Marta Cammilletti ont d\xE9croch\xE9 les m\xE9dailles d'or du tournoi international satellite de fleuret organis\xE9 \xE0 Tachkent, Ouzb\xE9kistan, les 25 et 26 septembre. </strong></p>\n        <p>De nombreux pays \xE9taient repr\xE9sent\xE9s par les quarante-huit athl\xE8tes en lice, \xE0 savoir la Bi\xE9lorussie, l'Iran, l'Irak, l'Italie, le Kazakhstan, les Philippines, la Turquie, les \xC9tats-Unis et l'Ouzb\xE9kistan. </p>\n        <p>Gassner s'est impos\xE9 en finale du fleuret masculin face au Bi\xE9lorusse Uladzislau Kurylovich (15-10). Les m\xE9dailles de bronze sont revenues \xE0 Akhmadillokhon Solikhojiev (UZB) et Mukhammad Yusuf Asranov (UZB). </p>\n        <p>Au fleuret f\xE9minin, Cammilletti a remport\xE9 la finale face \xE0 la Philippine Maxine Isabel Esteban (15-2). Madinabonu Parpieva (UZB) et Umida Ilyosova (UZB) ont d\xE9croch\xE9 le bronze. </p>\n        <p>La comp\xE9tition a \xE9t\xE9 organis\xE9e conform\xE9ment aux r\xE8glements de la FIE et au protocole relatif \xE0 la COVID-19..</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim\n            .fromTo(cOf(\"8-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"8-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"8-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"8-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          resetNumbers(\"8-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  L'AMÉRICAIN GASSNER ET L'ITALIENNE CAMMILLETTI REMPORTENT LE TOURNOI SATELLITE DE FLEURET DE TACHKENT TACHKENT, OUZBÉKISTAN 29 SEPTEMBRE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"9-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim\n            .fromTo(idOf(\"9-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n          resetNumbers(\"9-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "TOURNOI SATELLITE DE FLEURET TACHKENT, OUZBÉKISTAN, 2/2  L'Américain Ethan Gassner et l'Italienne Marta Cammilletti ont décroché les médailles d'or du tournoi international satellite de fleuret organisé à Tachkent, Ouzbékistan, les 25 et 26 septembre. De nombreux pays étaient représentés par les quarante-huit athlètes en lice, à savoir la Biélorussie, l'Iran, l'Irak, l'Italie, le Kazakhstan, les Philippines, la Turquie, les États-Unis et l'Ouzbékistan. Gassner s'est imposé en finale du fleuret masculin face au Biélorusse Uladzislau Kurylovich (15-10). Les médailles de bronze sont revenues à Akhmadillokhon Solikhojiev (UZB) et Mukhammad Yusuf Asranov (UZB). Au fleuret féminin, Cammilletti a remporté la finale face à la Philippine Maxine Isabel Esteban (15-2). Madinabonu Parpieva (UZB) et Umida Ilyosova (UZB) ont décroché le bronze. La compétition a été organisée conformément aux règlements de la FIE et au protocole relatif à la COVID-19. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 10-title\" style=\"top:102px;left:411px;\" src=\"/120/fr/static/_content/10-title-1.png\">\n        <img class=\"abs halfScale 10-sub\" style=\"top:300px;left:443px;\" src=\"/120/fr/static/_content/10-sub-1.png\">\n        <img class=\"abs halfScale 10-line\" style=\"top:303px;left:410px;\" src=\"/120/fr/static/_content/10-line-1.png\">\n        <img id=\"10-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"korea-s-kim-greece-s-georgiadou-win-2021-orleans-sabre-grand-prix\">L'or pour le Cor\xE9en Junghwan Kim et la Grecque Despina Georgiadou au Grand Prix de sabre d'Orl\xE9ans 2021</h2>\n        <img src=\"/120/fr/static/_content/10-mobile-1.jpg\">\n        <p><strong>Orl\xE9ans, France<br>13 Novembre 2021</strong></p>\n        <p><strong>Le Grand Prix de sabre d'Orl\xE9ans, premier Grand Prix de la FIE de la saison de comp\xE9tition 2021-2022, a \xE9t\xE9 remport\xE9 par le champion du monde cor\xE9en Junghwan Kim et la Grecque Despina Georgiadou. La comp\xE9tition, organis\xE9e au Z\xE9nith d'Orl\xE9ans, a \xE9t\xE9 disput\xE9e par 170 tireurs et 162 tireuses. </strong></p>\n        <p>Junghwan Kim a d\xE9croch\xE9 l'or du sabre masculin en terrassant en finale l'Italien Luca Curatoli (15-3). En demi-finale, Curatoli avait fait chuter le Japonais Kento Yoshida (15-10), et Kim avait \xE9limin\xE9 son co\xE9quipier, le champion du monde Sanguk Oh (15-13).</p>\n        <p>La finale du sabre f\xE9minin a \xE9t\xE9 remport\xE9e sur le fil par Despina Georgiadou face \xE0 sa co\xE9quipi\xE8re Theodora Gkountoura (15-14). En demi-finale, Gkountoura avait sorti la Cor\xE9enne Jisu Yoon (15-12), et Georgiadou avait \xE9vinc\xE9 la Russe Svetlana Sheveleva (15-12). Yoon avait notamment \xE9limin\xE9 en quart de finale une autre Cor\xE9enne, la championne olympique Jiyeon Kim (15-13).</p>\n        <p>Les huit premiers au classement du sabre masculin sont Junghwan Kim (KOR, or), Luca Curatoli (ITA, argent), Sanguk Oh (KOR, bronze), Kento Yoshida (JPN, bronze), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) et Enver Yildirim (TUR)./p>\n        <p>Les huit premi\xE8res au classement du sabre f\xE9minin sont Despina Georgiadou (GRE, or), Theodora Gkountoura (GRE, argent), Svetlana Sheveleva (RUS, bronze), Jisu Yoon (KOR, bronze), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) et Amalia Aime (FRA).</p>\n        <p>Retrouvez tous les r\xE9sultats officiels de la comp\xE9tition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualit\xE9 palpitante de l'escrime mondiale, regardez la s\xE9rie de vid\xE9os de la FIE sur notre cha\xEEne YouTube.</p>\n        <p>Pour revivre les matches des tournois masculin et f\xE9minin du Grand Prix de sabre d'Orl\xE9ans, cliquez ici..</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim\n            .fromTo(cOf(\"10-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"10-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"10-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"10-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg10Anim.stop();\n          resetNumbers(\"10-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  L'OR POUR LE CORÉEN JUNGHWAN KIM ET LA GRECQUE DESPINA GEORGIADOU AU GRAND PRIX DE SABRE D'ORLÉANS 2021 ORLÉANS, FRANCE 13 NOVEMBRE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"11-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim\n            .fromTo(idOf(\"11-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          resetNumbers(\"11-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "GRAND PRIX DE SABRE ORLÉANS, FRANCE 2/3  Le Grand Prix de sabre d'Orléans, premier Grand Prix de la FIE de la saison de compétition 2021-2022, a été remporté par le champion du monde coréen Junghwan Kim et la Grecque Despina Georgiadou. La compétition, organisée au Zénith d'Orléans, a été disputée par 170 tireurs et 162 tireuses. Junghwan Kim a décroché l'or du sabre masculin en terrassant en finale l'Italien Luca Curatoli (15-3). En demi-finale, Curatoli avait fait chuter le Japonais Kento Yoshida (15-10), et Kim avait éliminé son coéquipier, le champion du monde Sanguk Oh (15-13). La finale du sabre féminin a été remportée sur le fil par Despina Georgiadou face à sa coéquipière Theodora Gkountoura (15-14). En demi-finale, Gkountoura avait sorti la Coréenne Jisu Yoon (15-12), et Georgiadou avait évincé la Russe Svetlana Sheveleva (15-12). Yoon avait notamment éliminé en quart de finale une autre Coréenne, la championne olympique Jiyeon Kim (15-13). Les huit premiers au classement du sabre masculin sont Junghwan Kim (KOR, or),"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions/2022/158\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 60px; right: 557px; width: 215px; height: 20px;\"></div>\n          <div class=\"addContentLink\" style=\"bottom: 389px; right: 434px; width: 93px; height: 21px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 342px; right: 245px; width: 132px; height: 21px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo/videos\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 247px; right: 438px; width: 88px; height: 21px;\"></div>\n        </a>\n\n        <img id=\"12-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim\n            .fromTo(idOf(\"12-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          resetNumbers(\"12-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "GRAND PRIX DE SABRE ORLÉANS, FRANCE 3/3  Luca Curatoli (ITA, argent), Sanguk Oh (KOR, bronze), Kento Yoshida (JPN, bronze), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) et Enver Yildirim (TUR). Les huit premières au classement du sabre féminin sont Despina Georgiadou (GRE, or), Theodora Gkountoura (GRE, argent), Svetlana Sheveleva (RUS, bronze), Jisu Yoon (KOR, bronze), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) et Amalia Aime (FRA).  cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la série de vidéos de la FIE sur notre chaîne YouTube. Pour revivre les matches des tournois masculin et féminin du Grand Prix de sabre d'Orléans, cliquez ici. ■  Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:lammet@mail.ru\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 317px; right: 113px; width: 197px; height: 24px;\"></div> </a>\n        <a href=\"https://www.lammet.ru\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 292px; right: 177px; width: 132px; height: 24px;\"></div> </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.lammet.ru\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/13-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 14-title\" style=\"top:62px;left:61px;\" src=\"/120/fr/static/_content/14-title-1.png\">\n        <img class=\"abs halfScale 14-sub\" style=\"top:260px;left:97px;\" src=\"/120/fr/static/_content/14-sub-1.png\">\n        <img class=\"abs halfScale 14-line\" style=\"top:257px;left:64px;\" src=\"/120/fr/static/_content/14-line-1.png\">\n        <img id=\"14-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"france-s-jacques-andre-coquin-and-team-russia-win-glaive-de-tallinn-women-s-epee-world-cup\">\u200B\u200BCoupe du monde d'\xE9p\xE9e f\xE9minine : la Fran\xE7aise Jos\xE9phine Jacques-Andr\xE9-Coquin et l'\xE9quipe de Russie remportent le \xAB Glaive de Tallinn \xBB</h2>\n        <img src=\"/120/fr/static/_content/14-mobile-1.jpg\">\n        <p><strong>Tallinn, Estonie<br>19-21 Nov. 2021</strong></p>\n        <p>La Fran\xE7aise Jos\xE9phine Jacques-Andr\xE9-Coquin a remport\xE9 le titre individuel de la 51\xE8me \xE9dition du \xAB Glaive de Tallinn \xBB de la Coupe du monde d'\xE9p\xE9e f\xE9minine. L'\xE9quipe de Russie est repartie avec l'or de l'\xE9preuve par \xE9quipes. </p>\n        <p>Cette premi\xE8re \xE9tape de la Coupe du monde f\xE9minine senior de la FIE de la saison de comp\xE9titions 2021-2022, organis\xE9e au Kalev Sports Hall, a \xE9t\xE9 disput\xE9e par 246 \xE9p\xE9istes et 26 \xE9quipes.</p>\n        <p>Jos\xE9phine Jacques-Andr\xE9-Coquin a remport\xE9 l'or de l'\xE9p\xE9e individuelle en s'imposant en finale face \xE0 sa co\xE9quipi\xE8re Marie-Florence Candassamy sur le score de 15-11. En demi-finale, Candassamy avait battu l'Italienne Federica Isola (15-9) et Jacques-Andr\xE9-Coquin avait \xE9limin\xE9 sa co\xE9quipi\xE8re Alexandra Louis Marie (15-11).</p>\n        <p>La Russie a remport\xE9 la finale de l'\xE9preuve par \xE9quipes face \xE0 l'Allemagne (43-37). En demi-finale, l'Allemagne avait battu l'Italie (32-31) et la Russie avait \xE9limin\xE9 la Cor\xE9e (45-35). L'Italie a par la suite d\xE9croch\xE9 la m\xE9daille de bronze au d\xE9triment de la Cor\xE9e (45-33).</p>\n        <p>Les huit premi\xE8res au classement final de l'\xE9p\xE9e individuelle sont Jos\xE9phine Jacques-Andr\xE9-Coquin (FRA, or), Marie-Florence Candassamy (FRA, argent), Federica Isola (ITA, bronze), Alexandra Louis Marie (FRA, bronze), Renata Knapik-Miazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) et Lauren Rembi (FRA).</p>\n        <p>Au classement final de l'\xE9preuve par \xE9quipes, la Russie arrive en t\xEAte (or), suivie de l'Allemagne (argent), l'Italie (bronze), la Cor\xE9e, l'Estonie, la Suisse, la France et la Pologne.</p>\n        <p>Retrouvez tous les r\xE9sultats officiels de la comp\xE9tition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualit\xE9 palpitante de l'escrime mondiale, regardez la s\xE9rie de vid\xE9os de la FIE sur la cha\xEEne YouTube de la FIE.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim\n            .fromTo(cOf(\"14-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"14-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"14-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"14-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg14Anim.stop();\n          resetNumbers(\"14-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  COUPE DU MONDE D'ÉPÉE FÉMININE : LA FRANÇAISE JOSÉPHINE JACQUESANDRÉ-COQUIN ET L'ÉQUIPE DE RUSSIE REMPORTENT LE « GLAIVE DE TALLINN » TALLINN, ESTONIE 19-21 NOV. 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"15-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim\n            .fromTo(idOf(\"15-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          resetNumbers(\"15-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE D'ÉPÉE FÉMININE TALLINN, ESTONIE 2/3  La Française Joséphine JacquesAndré-Coquin a remporté le titre individuel de la 51ème édition du « Glaive de Tallinn » de la Coupe du monde d'épée féminine. L'équipe de Russie est repartie avec l'or de l'épreuve par équipes. Cette première étape de la Coupe du monde féminine senior de la FIE de la saison de compétitions 2021-2022, organisée au Kalev Sports Hall, a été disputée par 246 épéistes et 26 équipes.  Joséphine Jacques-André-Coquin a remporté l'or de l'épée individuelle en s'imposant en finale face à sa coéquipière Marie-Florence Candassamy sur le score de 15-11. En demifinale, Candassamy avait battu l'Italienne Federica Isola (15-9) et Jacques-André-Coquin avait éliminé sa coéquipière Alexandra Louis Marie (15-11). La Russie a remporté la finale de l'épreuve par équipes face à l'Allemagne (43-37). En demifinale, l'Allemagne avait battu l'Italie (32-31) et la Russie avait éliminé la Corée (45-35). L'Italie"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 295px; right: 433px; width: 94px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 249px; right: 200px; width: 208px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"16-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim\n            .fromTo(idOf(\"16-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE D'ÉPÉE FÉMININE TALLINN, ESTONIE 3/3  a par la suite décroché la médaille de bronze au détriment de la Corée (45-33). Les huit premières au classement final de l'épée individuelle sont Joséphine Jacques-AndréCoquin (FRA, or), Marie-Florence Candassamy (FRA, argent), Federica Isola (ITA, bronze), Alexandra Louis Marie (FRA, bronze), Renata Knapik-Miazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) et Lauren Rembi (FRA). Au classement final de l'épreuve par équipes, la Russie arrive en tête (or), suivie de l'Allemagne (argent), l'Italie (bronze), la Corée, l'Estonie, la Suisse, la France et la Pologne. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la série de vidéos de la FIE sur la chaîne YouTube de la FIE. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 17-title\" style=\"top:74px;left:66px;\" src=\"/120/fr/static/_content/17-title-1.png\">\n        <img class=\"abs halfScale 17-sub\" style=\"top:235px;left:97px;\" src=\"/120/fr/static/_content/17-sub-1.png\">\n        <img class=\"abs halfScale 17-line\" style=\"top:233px;left:64px;\" src=\"/120/fr/static/_content/17-line-1.png\">\n        <img id=\"17-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"venezuela-s-limardo-gascon-team-russia-win-bern-men-s-epee-world-cup\">Coupe du monde d'\xE9p\xE9e masculine : l'or pour le V\xE9n\xE9zu\xE9lien Limardo Gascon et l'\xE9quipe de Russie</h2>\n        <img src=\"/120/fr/static/_content/17-mobile-1.jpg\">\n        <p>\u200B\u200B<strong>Bern, Suisse<br>19-21 Novembre 2021</strong></p>\n        <p><strong>Le champion olympique v\xE9n\xE9zu\xE9lien Ruben Limardo Gascon a remport\xE9 le titre individuel de la Coupe du monde d'\xE9p\xE9e masculine de Bern.   </strong></p>\n        <p>L'\xE9quipe de Russie est repartie avec l'or de l'\xE9preuve par \xE9quipes. Cette premi\xE8re \xE9tape de la Coupe du monde masculine senior de la FIE de la saison de comp\xE9titions 2021-2022 a \xE9t\xE9 disput\xE9e par 265 \xE9p\xE9istes et 33 \xE9quipes. La comp\xE9tition s'est d\xE9roul\xE9e dans le Sporthalle Wankdorf de Berne.</p>\n        <p>Limardo Gascon a remport\xE9 l'or de l'\xE9p\xE9e individuelle en s'imposant en finale face au Fran\xE7ais Alexandre Bardenet sur le score de 15-7. En demi-finale, Bardenet avait sorti l'un de ses co\xE9quipiers, le champion olympique Romain Cannone (15-9), et Limardo Gascon avait \xE9limin\xE9 sur le fil l'Italien Andrea Santarelli (10-9). En quart de finale, Bardenet avait \xE9galement d\xFB affronter un autre membre de l'\xE9quipe de France, le champion du monde Yannick Borel, battu 15 touches \xE0 9.</p>\n        <p>Les Russes ont ravi le titre par \xE9quipes \xE0 des Espagnols combatifs qui n'ont conc\xE9d\xE9 la victoire en finale que d'une petite touche (45-44). En demi-finale, l'Espagne avait domin\xE9 la Hongrie (45-42) et la Russie avait \xE9limin\xE9 le Japon (45-34). Le Japon est reparti avec la m\xE9daille de bronze apr\xE8s une victoire sur la Hongrie (45-34).</p>\n        <p>Les huit premiers au classement final de l'\xE9preuve individuelle sont Ruben Limardo Gascon (VEN, or), Alexandre Bardenet (FRA, argent), Romain Cannone (FRA, bronze), Andrea Santarelli (ITA, bronze), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) et Georgiy Bruev (RUS).</p>\n        <p>Au classement final de l'\xE9preuve par \xE9quipes, la Russie arrive en t\xEAte (or), suivie de l'Espagne (argent), du Japon (bronze), de la Hongrie, de la France, de l'Ukraine, du Danemark et de l'Italie.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim\n            .fromTo(cOf(\"17-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"17-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"17-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"17-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg17Anim.stop();\n          resetNumbers(\"17-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  COUPE DU MONDE D'ÉPÉE MASCULINE : L'OR POUR LE VÉNÉZUÉLIEN LIMARDO GASCON ET L'ÉQUIPE DE RUSSIE BERN, SUISSE 19-21 NOVEMBRE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"18-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim\n            .fromTo(idOf(\"18-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          resetNumbers(\"18-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE D'ÉPÉE MASCULINE BERN, SUISSE 2/2  Le champion olympique vénézuélien Ruben Limardo Gascon a remporté le titre individuel de la Coupe du monde d'épée masculine de Bern. L'équipe de Russie est repartie avec l'or de l'épreuve par équipes. Cette première étape de la Coupe du monde masculine senior de la FIE de la saison de compétitions 2021-2022 a été disputée par 265 épéistes et 33 équipes. La compétition s'est déroulée dans le Sporthalle Wankdorf de Berne. Limardo Gascon a remporté l'or de l'épée individuelle en s'imposant en finale face au Français Alexandre Bardenet sur le score de 15-  7. En demi-finale, Bardenet avait sorti l'un de ses coéquipiers, le champion olympique Romain Cannone (15-9), et Limardo Gascon avait éliminé sur le fil l'Italien Andrea Santarelli (109). En quart de finale, Bardenet avait également dû affronter un autre membre de l'équipe de France, le champion du monde Yannick Borel, battu 15 touches à 9. Les Russes ont ravi le titre par équipes à des Espagnols combatifs qui n'ont concédé la victoire en finale que d'une petite touche (45-44). En demi-finale, l'Espagne avait dominé la Hongrie (45-42) et la Russie avait éliminé le Japon (4534). Le Japon est reparti avec la médaille de bronze après une victoire sur la Hongrie (45-34). Les huit premiers au classement final de l'épreuve individuelle sont Ruben Limardo Gascon (VEN, or), Alexandre Bardenet (FRA, argent), Romain Cannone (FRA, bronze), Andrea Santarelli (ITA, bronze), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) et Georgiy Bruev (RUS). Au classement final de l'épreuve par équipes, la Russie arrive en tête (or), suivie de l'Espagne (argent), du Japon (bronze), de la Hongrie, de la France, de l'Ukraine, du Danemark et de l'Italie. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/fr/static/_content/19-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 20-title\" style=\"top:56px;left:453px;\" src=\"/120/fr/static/_content/20-title-1.png\">\n        <img class=\"abs halfScale 20-sub\" style=\"top:218px;left:485px;\" src=\"/120/fr/static/_content/20-sub-1.png\">\n        <img class=\"abs halfScale 20-line\" style=\"top:220px;left:453px;\" src=\"/120/fr/static/_content/20-line-1.png\">\n        <img id=\"20-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"italy-s-alice-volpi-and-team-italy-win-gold-at-st-maur-women-s-foil-world-cup\">Un doubl\xE9 en or pour l'Italie \xE0 la Coupe du monde de fleuret f\xE9minin \xE0 Saint-Maur</h2>\n        <img src=\"/120/fr/static/_content/20-mobile-1.jpg\">\n        <p><strong>Saint-Maur-des-Foss\xE9s, France<br>12 D\xE9cembre 2021</strong></p>\n        <p><strong>La championne du monde italienne Alice Volpi a remport\xE9 l'or de l'\xE9preuve individuelle de la Coupe du monde de fleuret f\xE9minin de Saint-Maur, avant de remonter sur la plus haute marche du podium aux c\xF4t\xE9s de ses co\xE9quipi\xE8res de l'\xE9quipe nationale italienne \xE0 l'issue de l'\xE9preuve par \xE9quipes. </strong></p>\n        <p>La comp\xE9tition, organis\xE9e au Centre sportif Pierre Brossolette, a \xE9t\xE9 disput\xE9e par 182 fleurettistes et 20 \xE9quipes.</p>\n        <p>Alice Volpi a remport\xE9 la finale de l'\xE9preuve de fleuret individuel \xE0 la touche en or face \xE0 la championne olympique am\xE9ricaine Lee Kiefer (15-14). En demi-finale, Kiefer n'avait fait qu'une bouch\xE9e de sa co\xE9quipi\xE8re Jacqueline Dubrovich (15-4), Volpi \xE9liminant quant \xE0 elle sa co\xE9quipi\xE8re Francesca Palumbo (15-12).</p>\n        <p>L'Italie a remport\xE9 la finale de l'\xE9preuve de fleuret f\xE9minin par \xE9quipes face au Japon sur le score de 43-40. En demi-finale, le Japon avait \xE9limin\xE9 la Russie (31-26), et l'Italie s'\xE9tait impos\xE9e face au Canada (45-37). La m\xE9daille de bronze est revenue aux Russes apr\xE8s une victoire serr\xE9e en petite finale face aux Canadiennes (44-39).</p>\n        <p>Les huit premi\xE8res au classement de l'\xE9preuve individuelle de fleuret f\xE9minin de la Coupe du monde de Saint-Maur sont Alice Volpi (ITA, or), Lee Kiefer (USA, argent), Jacqueline Dubrovich (USA, bronze), Francesca Palumbo (ITA, bronze), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) et Kiyeun Kim (KOR).</p>\n        <p>Au classement de l'\xE9preuve de fleuret f\xE9minin par \xE9quipes, l'Italie arrive en t\xEAte (or), suivie du Japon (argent), de la Russie (bronze), du Canada, de la Pologne, de la Chine, des \xC9tats-Unis et de Hong Kong.</p>\n        <p>Retrouvez tous les r\xE9sultats officiels de la comp\xE9tition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualit\xE9 palpitante de l'escrime mondiale, regardez la cha\xEEne YouTube de la FIE.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim\n            .fromTo(cOf(\"20-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"20-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"20-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"20-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  UN DOUBLÉ EN OR POUR L'ITALIE À LA COUPE DU MONDE DE FLEURET FÉMININ À SAINT-MAUR SAINT-MAUR-DES-FOSSÉS, FRANCE 12 DÉCEMBRE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 108px; right: 425px; width: 102px; height: 20px; \"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 83px; right: 151px; width: 57px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 61px; right: 375px; width: 152px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"21-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim\n            .fromTo(idOf(\"21-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          resetNumbers(\"21-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE DE FLEURET FÉMININ SAINT-MAUR-DESFOSSÉS, FRANCE 2/2  La championne du monde italienne Alice Volpi a remporté l'or de l'épreuve individuelle de la Coupe du monde de fleuret féminin de Saint-Maur, avant de remonter sur la plus haute marche du podium aux côtés de ses coéquipières de l'équipe nationale italienne à l'issue de l'épreuve par équipes. La compétition, organisée au Centre sportif Pierre Brossolette, a été disputée par 182 fleurettistes et 20 équipes. Alice Volpi a remporté la finale de l'épreuve de fleuret individuel à la touche en or face à la championne olympique américaine Lee Kiefer (15-14). En demi-finale, Kiefer n'avait fait qu'une bouchée de sa coéquipière Jacqueline Dubrovich (15-4), Volpi éliminant quant à elle sa coéquipière Francesca Palumbo (15-12). L'Italie a remporté la finale de l'épreuve de fleuret féminin par équipes face au Japon sur le score de 43-40. En demi-finale, le Japon avait éliminé la Russie (31-26), et l'Italie s'était imposée face au Canada (45-37). La médaille de bronze est revenue aux Russes après une victoire serrée en petite finale face aux Canadiennes (44-39).  Les huit premières au classement de l'épreuve individuelle de fleuret féminin de la Coupe du monde de Saint-Maur sont Alice Volpi (ITA, or), Lee Kiefer (USA, argent), Jacqueline Dubrovich (USA, bronze), Francesca Palumbo (ITA, bronze), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) et Kiyeun Kim (KOR). Au classement de l'épreuve de fleuret féminin par équipes, l'Italie arrive en tête (or), suivie du Japon (argent), de la Russie (bronze), du Canada, de la Pologne, de la Chine, des ÉtatsUnis et de Hong Kong. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 22-title\" style=\"top:64px;left:332px;\" src=\"/120/fr/static/_content/22-title-1.png\">\n        <img class=\"abs halfScale 22-sub\" style=\"top:308px;left:364px;\" src=\"/120/fr/static/_content/22-sub-1.png\">\n        <img class=\"abs halfScale 22-line\" style=\"top:306px;left:332px;\" src=\"/120/fr/static/_content/22-line-1.png\">\n        <img id=\"22-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"hong-kong-s-cheung-team-italy-take-gold-in-challenge-international-de-paris-men-s-foil-world-cup\">Le Hongkongais Cheung et l'\xE9quipe d'Italie couronn\xE9s d'or au Challenge International de Paris de la Coupe du monde de fleuret masculin</h2>\n        <img src=\"/120/fr/static/_content/22-mobile-1.jpg\">\n        <p><strong>Paris, France<br>14-16 Janvier 2022</strong></p>\n        <p><strong>Le champion olympique hongkongais Ka Long Cheung a remport\xE9 le titre individuel du Challenge International de Paris de la Coupe du monde de fleuret masculin.  </strong></p>\n        <p>L'\xE9quipe d'Italie est repartie avec l'or de l'\xE9preuve par \xE9quipes. La comp\xE9tition, qui s'est d\xE9roul\xE9e au stade Pierre de Coubertin, a attir\xE9 210 fleurettistes et 26 \xE9quipes.</p>\n        <p>En finale du fleuret individuel, Cheung a battu l'Italien Edoardo Luperi sur le score de 15 touches \xE0 12. En demi-finale, Luperi avait \xE9limin\xE9 l'Am\xE9ricain Chase Emmer (15-13) et Cheung avait terrass\xE9 le champion du monde italien Alessio Foconi (15-4). En quart de finale, Cheung avait \xE9galement mis fin au parcours du champion du monde fran\xE7ais Enzo Lefort (15-9), et Emmer avait sorti le champion olympique italien Daniele Garozzo (15-5).</p>\n        <p>L'Italie a remport\xE9 l'or de l'\xE9preuve de fleuret par \xE9quipes en s'imposant en finale face \xE0 la France (45-20). En demi-finale, la France avait \xE9limin\xE9 la Russie (45-39) et l'Italie avait fait chuter les \xC9tats-Unis (45-38). Les Am\xE9ricains ont remport\xE9 la m\xE9daille de bronze en battant les Russes 45 touches \xE0 31.</p>\n        <p>Les huit premiers au classement final du fleuret individuel sont Ka Long Cheung (HKG, or), Edoardo Luperi (ITA, argent), Chase Emmer (USA, bronze), Alessio Foconi (ITA, bronze), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) et Alexandre Sido (FRA).</p>\n        <p>Au classement final de l'\xE9preuve de fleuret par \xE9quipes, l'Italie arrive en t\xEAte (or), suivie de la France (argent), des \xC9tats-Unis (bronze), de la Russie, du Japon, de l'\xC9gypte, de la Cor\xE9e et de Hong Kong.</p>\n        <p>Retrouvez tous les r\xE9sultats officiels de la comp\xE9tition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualit\xE9 palpitante de l'escrime mondiale, regardez la cha\xEEne YouTube de la FIE.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim\n            .fromTo(cOf(\"22-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"22-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"22-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"22-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg22Anim.stop();\n          resetNumbers(\"22-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  LE HONGKONGAIS CHEUNG ET L'ÉQUIPE D'ITALIE COURONNÉS D'OR AU CHALLENGE INTERNATIONAL DE PARIS DE LA COUPE DU MONDE DE FLEURET MASCULIN PARIS, FRANCE 14-16 JANVIER 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 131px; right: 177px; width: 192px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 84px; right: 150px; width: 59px; height: 20px;\"></div>\n          <div class=\"addContentLink\" style=\"bottom: 60px; right: 375px; width: 151px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"23-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim\n            .fromTo(idOf(\"23-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          resetNumbers(\"23-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE DE FLEURET MASCULIN PARIS, FRANCE 2/2  Le champion olympique hongkongais Ka Long Cheung a remporté le titre individuel du Challenge International de Paris de la Coupe du monde de fleuret masculin. L'équipe d'Italie est repartie avec l'or de l'épreuve par équipes. La compétition, qui s'est déroulée au stade Pierre de Coubertin, a attiré 210 fleurettistes et 26 équipes. En finale du fleuret individuel, Cheung a battu l'Italien Edoardo Luperi sur le score de 15 touches à 12. En demi-finale, Luperi avait éliminé l'Américain Chase Emmer (15-13) et Cheung avait terrassé le champion du monde italien Alessio Foconi (15-4). En quart de finale, Cheung avait également mis fin au parcours du champion du monde français Enzo Lefort (159), et Emmer avait sorti le champion olympique italien Daniele Garozzo (15-5). L'Italie a remporté l'or de l'épreuve de fleuret par équipes en s'imposant en finale face à la France (45-20). En demi-finale, la France avait éliminé la Russie (45-39) et l'Italie avait fait chuter les États-Unis (45-38). Les Américains ont remporté la médaille de bronze en battant les Russes 45 touches à 31.  Les huit premiers au classement final du fleuret individuel sont Ka Long Cheung (HKG, or), Edoardo Luperi (ITA, argent), Chase Emmer (USA, bronze), Alessio Foconi (ITA, bronze), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) et Alexandre Sido (FRA). Au classement final de l'épreuve de fleuret par équipes, l'Italie arrive en tête (or), suivie de la France (argent), des États-Unis (bronze), de la Russie, du Japon, de l'Égypte, de la Corée et de Hong Kong. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.blaise-freres.fr\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"  bottom: 173px; right: 981px; width: 177px; height: 25px; }\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.blaise-freres.fr\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/pg24.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 25-title\" style=\"top:86px;left:485px;\" src=\"/120/fr/static/_content/25-sub-2.png\">\n        <img class=\"abs halfScale 25-sub\" style=\"top:276px;left:770px;\" src=\"/120/fr/static/_content/25-sub-1.png\">\n        <img class=\"abs halfScale 25-line\" style=\"top:273px;left:738px;\" src=\"/120/fr/static/_content/25-line-1.png\">\n        <img id=\"25-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"italy-s-volpi-team-usa-win-gold-at-poznan-women-s-foil-world-cup\">\n          Coupe du monde de fleuret f\xE9minin : l'or pour l'Italienne Volpi et les Am\xE9ricaines \xE0 Poznan</h2>\n        <p><strong>Poznan, Pologne<br>14-16 Janvier 2022</strong></p>\n        <img src=\"/120/fr/static/_content/25-mobile-1.jpg\">\n        <p><strong>La championne du monde italienne Alice Volpi a remport\xE9 l'or de l'\xE9preuve individuelle de la Coupe du monde de fleuret f\xE9minin \xE0 Poznan, et les \xC9tats-Unis le titre de l'\xE9preuve par \xE9quipes. </strong></p>\n        <p>La comp\xE9tition, organis\xE9e \xE0 l'UAM Sport Center, a \xE9t\xE9 disput\xE9e par 180 fleurettistes et 20 \xE9quipes.</p>\n        <p>Volpi a remport\xE9 la finale de l'\xE9preuve individuelle face \xE0 la Canadienne Eleanor Harvey sur le score de 15 touches \xE0 10. En demi-finale, Harvey avait battu la Chinoise Qingyuan Chen (15-7) et Volpi avait \xE9limin\xE9 sa co\xE9quipi\xE8re Martina Favaretto (15-11).</p>\n        <p>Les Am\xE9ricaines ont d\xE9croch\xE9 l'or par \xE9quipes en s'adjugeant la victoire en finale face au Japon sur le score de 45-23. En demi-finale, le Japon avait \xE9limin\xE9 la Pologne (27-25) et les \xC9tats-Unis s'\xE9taient impos\xE9s face \xE0 la Russie (45-39). La Pologne a d\xE9croch\xE9 la m\xE9daille de bronze en battant la Russie en petite finale 44 touches \xE0 42.</p>\n        <p>Les huit premi\xE8res au classement du fleuret individuel sont Alice Volpi (ITA, or), Eleanor Harvey (CAN, argent), Martina Favaretto (ITA, bronze), Qingyuan Chen (CHN, bronze), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) et Elena Petrova (RUS).</p>\n        <p>Au classement du fleuret par \xE9quipes, les \xC9tats-Unis arrivent en t\xEAte (or), suivis du Japon (argent), de la Pologne (bronze), de la Russie, de l'Italie, de la Chine, de la France et du Canada.</p>\n        <p>Retrouvez tous les r\xE9sultats officiels de la comp\xE9tition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualit\xE9 palpitante de l'escrime mondiale, regardez la cha\xEEne YouTube de la FIE.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim\n            .fromTo(cOf(\"25-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"25-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"25-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"25-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg25Anim.stop();\n          resetNumbers(\"25-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  COUPE DU MONDE DE FLEURET FÉMININ : L'OR POUR L'ITALIENNE VOLPI ET LES AMÉRICAINES À POZNAN POZNAN, POLOGNE 14-16 JANVIER 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 178px; right: 178px; width: 213px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 131px; right: 150px; width: 129px; height: 20px;\"></div>\n          <div class=\"addContentLink\" style=\"bottom: 109px; right: 450px; width: 75px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"26-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim\n            .fromTo(idOf(\"26-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          resetNumbers(\"26-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE DE FLEURET FÉMININ POZNAN, POLOGNE 2/2  La championne du monde italienne Alice Volpi a remporté l'or de l'épreuve individuelle de la Coupe du monde de fleuret féminin à Poznan, et les ÉtatsUnis le titre de l'épreuve par équipes. La compétition, organisée à l'UAM Sport Center, a été disputée par 180 fleurettistes et 20 équipes. Volpi a remporté la finale de l'épreuve individuelle face à la Canadienne Eleanor Harvey sur le score de 15 touches à 10. En demi-finale, Harvey avait battu la Chinoise Qingyuan Chen (15-7) et Volpi avait éliminé sa coéquipière Martina Favaretto (15-11).  Les Américaines ont décroché l'or par équipes en s'adjugeant la victoire en finale face au Japon sur le score de 45-23. En demi-finale, le Japon avait éliminé la Pologne (27-25) et les États-Unis s'étaient imposés face à la Russie (45-39). La Pologne a décroché la médaille de bronze en battant la Russie en petite finale 44 touches à 42. Les huit premières au classement du fleuret individuel sont Alice Volpi (ITA, or), Eleanor Harvey (CAN, argent), Martina Favaretto (ITA, bronze), Qingyuan Chen (CHN, bronze), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) et Elena Petrova (RUS). Au classement du fleuret par équipes, les États-Unis arrivent en tête (or), suivis du Japon (argent), de la Pologne (bronze), de la Russie, de l'Italie, de la Chine, de la France et du Canada. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 27-title\" style=\"top:64px;left:423px;\" src=\"/120/fr/static/_content/27-title-1.png\">\n        <img class=\"abs halfScale 27-sub\" style=\"top:301px;left:454px;\" src=\"/120/fr/static/_content/27-sub-1.png\">\n        <img class=\"abs halfScale 27-line\" style=\"top:304px;left:422px;\" src=\"/120/fr/static/_content/27-line-1.png\">\n        <img id=\"27-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n      <h2\n        id=\"georgia-s-bazadze-france-s-queroli-teams-korea-and-france-win-gold-at-tbilisi-sabre-world-cup\">Coupe de monde de sabre : l'or \xE0 Tbilissi pour le G\xE9orgien Bazadze, la Fran\xE7aise Queroli, l'\xE9quipe de Cor\xE9e et l'\xE9quipe de France</h2>\n        <p><strong>Tbilissi, G\xE9orgie<br>14-18 Janvier 2022</strong></p>\n        <img src=\"/120/fr/static/_content/27-mobile-1.jpg\">\n        <p><strong>Le G\xE9orgien Sandro Bazadze et la Fran\xE7aise Caroline Queroli ont remport\xE9 l'or des \xE9preuves individuelles de la Coupe du monde de sabre de Tbilissi. </strong></p>\n        <p>La Cor\xE9e et la France s'octroient l'or des \xE9preuves par \xE9quipes masculine et f\xE9minine. La comp\xE9tition, organis\xE9e \xE0 l'Olympic Palace, a \xE9t\xE9 disput\xE9e par 188 tireurs et 154 tireuses en individuel, et 24 \xE9quipes masculines et 25 \xE9quipes f\xE9minines.</p>\n        <p>Bazadze a battu le Russe Kamil Ibragimov en finale du sabre individuel masculin sur le score de 15-8. En demi-finale, Ibragimov avait \xE9limin\xE9 le champion du monde cor\xE9en Junghwan Kim (15-12) et Bazadze avait sorti le Fran\xE7ais Bolade Apithy (15-10). En quart de finale, Apithy avait \xE9vinc\xE9 le champion du monde cor\xE9en Sanguk Oh (15-8) et Kim avait battu le champion du monde hongrois Andras Szatmari (15-12).</p>\n        <p>La finale du sabre f\xE9minin individuel a \xE9t\xE9 remport\xE9e par Queroli face \xE0 la Grecque Theodora Gkountoura sur le score de 15-12. En demi-finale, Gkountoura a d\xFB puiser dans ses ressources pour battre la championne olympique russe Yana Egorian (15-14), tout comme Queroli victorieuse sur le fil de l'Italienne Rossella Gregorio (15-14).</p>\n        <p>Au sabre masculin par \xE9quipes, la Cor\xE9e a remport\xE9 la finale face \xE0 l'Allemagne (45-38). En demi-finale, les Allemands avaient \xE9limin\xE9 les Italiens (45-43) et les Cor\xE9ens avaient battu les Russes (45-44). La Russie est repartie avec la m\xE9daille de bronze au d\xE9triment de l'Italie (45-40).</p>\n        <p>Au sabre f\xE9minin par \xE9quipes, la France est mont\xE9e sur la plus haute marche du podium apr\xE8s avoir vaincu la Cor\xE9e en finale (45-35). En demi-finale, la France avait battu l'Espagne (45-34) et la Cor\xE9e avait \xE9limin\xE9 la Russie (45-39). La m\xE9daille de bronze est revenue aux Russes apr\xE8s une victoire serr\xE9e en petite finale face aux Espagnoles (45-43).</p>\n        <p>Les huit premi\xE8res au classement final du sabre individuel f\xE9minin sont Caroline Qu\xE9roli (FRA, or), Theod\xF3ra Gkounto\xFAra (GRE, argent), Yana Egorian (RUS, bronze), Rossella Gregorio (ITA, bronze), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) et Seri Ozaki (JPN).</p>\n        <p>Les huit premi\xE8res \xE9quipes au classement final du sabre masculin par \xE9quipes sont la Cor\xE9e (or), l'Allemagne (argent), la Russie (bronze), l'Italie, l'Iran, l'\xC9gypte, la Hongrie et la France.</p>\n        <p>Les huit premi\xE8res \xE9quipes au classement final du sabre f\xE9minin par \xE9quipes sont la France (or), la Cor\xE9e (argent), la Russie (bronze), l'Espagne, l'Italie, la Bulgarie, la Hongrie et la Pologne..</p>\n        <p>Retrouvez tous les r\xE9sultats officiels de la comp\xE9tition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualit\xE9 palpitante de l'escrime mondiale, regardez la cha\xEEne YouTube de la FIE.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim\n            .fromTo(cOf(\"27-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"27-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"27-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"27-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg27Anim.stop();\n          resetNumbers(\"27-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  COUPE DE MONDE DE SABRE : L'OR À TBILISSI POUR LE GÉORGIEN BAZADZE, LA FRANÇAISE QUEROLI, L'ÉQUIPE DE CORÉE ET L'ÉQUIPE DE FRANCE TBILISSI, GÉORGIE 14-18 JANVIER 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"28-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim\n            .fromTo(idOf(\"28-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          resetNumbers(\"28-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DE MONDE DE SABRE TBILISI, GÉORGIE 2/3  Le Géorgien Sandro Bazadze et la Française Caroline Queroli ont remporté l'or des épreuves individuelles de la Coupe du monde de sabre de Tbilissi. La Corée et la France s'octroient l'or des épreuves par équipes masculine et féminine. La compétition, organisée à l'Olympic Palace, a été disputée par 188 tireurs et 154 tireuses en individuel, et 24 équipes masculines et 25 équipes féminines. Bazadze a battu le Russe Kamil Ibragimov en finale du sabre individuel masculin sur le score de 15-8. En demi-finale, Ibragimov avait éliminé le champion du monde coréen Junghwan Kim (15-12) et Bazadze avait sorti le Français Bolade Apithy (15-10). En quart de finale, Apithy avait évincé le champion du monde coréen Sanguk Oh (15-8) et Kim avait battu le champion du monde hongrois Andras Szatmari (15-12). La finale du sabre féminin individuel a été remportée par Queroli face à la Grecque Theodora Gkountoura sur le score de 15-12. En demi-finale, Gkountoura a dû puiser dans ses ressources pour battre la championne olympique russe Yana Egorian (15-14), tout  comme Queroli victorieuse sur le fil de l'Italienne Rossella Gregorio (15-14). Au sabre masculin par équipes, la Corée a remporté la finale face à l'Allemagne (45-38). En demi-finale, les Allemands avaient éliminé les Italiens (45-43) et les Coréens avaient battu les Russes (45-44). La Russie est repartie avec la médaille de bronze au détriment de l'Italie (45-40)."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 296px; right: 435px; width: 91px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 272px; right: 150px; width: 127px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 249px; right: 451px; width: 74px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"29-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim\n            .fromTo(idOf(\"29-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          resetNumbers(\"29-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DE MONDE DE SABRE TBILISI, GÉORGIE 3/3  Au sabre féminin par équipes, la France est montée sur la plus haute marche du podium après avoir vaincu la Corée en finale (45-35). En demi-finale, la France avait battu l'Espagne (45-34) et la Corée avait éliminé la Russie (4539). La médaille de bronze est revenue aux Russes après une victoire serrée en petite finale face aux Espagnoles (45-43). Les huit premières au classement final du sabre individuel féminin sont Caroline Quéroli (FRA, or), Theodóra Gkountoúra (GRE, argent), Yana Egorian (RUS, bronze), Rossella Gregorio (ITA, bronze), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) et Seri Ozaki (JPN). Les huit premières équipes au classement final du sabre masculin par équipes sont la Corée (or), l'Allemagne (argent), la Russie (bronze), l'Italie, l'Iran, l'Égypte, la Hongrie et la France.  Les huit premières équipes au classement final du sabre féminin par équipes sont la France (or), la Corée (argent), la Russie (bronze), l'Espagne, l'Italie, la Bulgarie, la Hongrie et la Pologne. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.facebook.com/uhlmann.fencing/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 1095px; width: 19px; height: 18px;\"></div>\n        </a>\n        <a href=\"https://www.instagram.com/uhlmann.fencing/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 1074px; width: 19px; height: 18px;\"></div>\n        </a>\n        <a href=\"https://uhlmann-fechtsport.com/en/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 966px; width: 104px; height: 18px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://uhlmann-fechtsport.com/en/\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/30-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 31-title\" style=\"top:73px;left:65px;\" src=\"/120/fr/static/_content/31-title-1.png\">\n        <img class=\"abs halfScale 31-sub\" style=\"top:232px;left:97px;\" src=\"/120/fr/static/_content/31-sub-1.png\">\n        <img class=\"abs halfScale 31-line\" style=\"top:231px;left:64px;\" src=\"/120/fr/static/_content/31-line-1.png\">\n        <img id=\"31-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"azerbaijans-bashta-team-france-win-gold-at-women-s-sabre-world-cup\">Coupe du Monde de Sabre F\xE9minin : l'Azerba\xEFdjanaise Anna Bashta et l'\xE9quipe de France remportent l'or \xE0 Plovdiv</h2>\n        <img src=\"/120/fr/static/_content/31-mobile-1.jpg\">\n        <p><strong>Plovdiv, Bulgarie<br>28-30 Janvier 2022</strong></p>\n        <p><strong>L'Azerba\xEFdjanaise Anna Bashta et l'\xE9quipe de France ont d\xE9croch\xE9 les m\xE9dailles d'or de la Coupe du monde de sabre f\xE9minin \xE0 Plovdiv, Bulgarie.  </strong></p>\n        <p>La comp\xE9tition, organis\xE9e au Complex SILA, a \xE9t\xE9 disput\xE9e par 136 sabreuses et 20 \xE9quipes.</p>\n        <p>Bashta a remport\xE9 la finale de l'\xE9preuve individuelle face \xE0 la Fran\xE7aise Manon Apithy-Brunet (15-10). En demi-finale, Apithy-Brunet avait \xE9limin\xE9 sa co\xE9quipi\xE8re Malina Vongsavady (15-9) et Bashta avait fait chuter l'Italienne Rossella Gregorio (15-13).</p>\n        <p>Dans l'\xE9preuve par \xE9quipes, la France a battu l'Azerba\xEFdjan en finale sur le score de 45 touches \xE0 39. En demi-finale, les Azerba\xEFdjanaises avaient \xE9cart\xE9 les Bulgares (45-32), et les Fran\xE7aises avaient \xE9limin\xE9 les Italiennes (45-23). L'Italie a par la suite remport\xE9 la m\xE9daille de bronze au d\xE9triment de la Bulgarie (45-29).</p>\n        <p>Les huit premi\xE8res au classement final de l'\xE9preuve de sabre individuel sont Anna Bashta (AZE, or), Manon Apithy-Brunet (FRA, argent), Rossella Gregorio (ITA, bronze), Malina Vongsavady (FRA, bronze), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) et Svetlana Sheveleva (RUS).</p>\n        <p>Au classement de la comp\xE9tition de sabre par \xE9quipes, la France arrive premi\xE8re (or), suivie de l'Azerba\xEFdjan (argent), l'Italie (bronze), la Bulgarie, la Hongrie, l'Espagne, la Turquie et l'Allemagne.</p>\n        <p>Retrouvez tous les r\xE9sultats officiels de la comp\xE9tition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualit\xE9 palpitante de l'escrime mondiale, regardez la cha\xEEne YouTube de la FIE.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim\n            .fromTo(cOf(\"31-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"31-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"31-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"31-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg31Anim.stop();\n          resetNumbers(\"31-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  COUPE DU MONDE DE SABRE FÉMININ : L'AZERBAÏDJANAISE ANNA BASHTA ET L'ÉQUIPE DE FRANCE REMPORTENT L'OR À PLOVDIV PLOVDIV, BULGARIA 28-30 JANUARY 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 107px; right: 435px; width: 92px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 83px; right: 150px; width: 129px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 61px; right: 450px; width: 76px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"32-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim\n            .fromTo(idOf(\"32-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n          resetNumbers(\"32-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE DE SABRE FÉMININ PLOVDIV, BULGARIE, 2/2  L'Azerbaïdjanaise Anna Bashta et l'équipe de France ont décroché les médailles d'or de la Coupe du monde de sabre féminin à Plovdiv, Bulgarie. La compétition, organisée au Complex SILA, a été disputée par 136 sabreuses et 20 équipes. Bashta a remporté la finale de l'épreuve individuelle face à la Française Manon ApithyBrunet (15-10). En demi-finale, Apithy-Brunet avait éliminé sa coéquipière Malina Vongsavady (15-9) et Bashta avait fait chuter l'Italienne Rossella Gregorio (15-13). Dans l'épreuve par équipes, la France a battu l'Azerbaïdjan en finale sur le score de 45 touches à 39. En demi-finale, les Azerbaïdjanaises avaient écarté les Bulgares (45-32), et les Françaises avaient éliminé les Italiennes (45-23). L'Italie a  par la suite remporté la médaille de bronze au détriment de la Bulgarie (45-29). Les huit premières au classement final de l'épreuve de sabre individuel sont Anna Bashta (AZE, or), Manon Apithy-Brunet (FRA, argent), Rossella Gregorio (ITA, bronze), Malina Vongsavady (FRA, bronze), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) et Svetlana Sheveleva (RUS). Au classement de la compétition de sabre par équipes, la France arrive première (or), suivie de l'Azerbaïdjan (argent), l'Italie (bronze), la Bulgarie, la Hongrie, l'Espagne, la Turquie et l'Allemagne. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 33-title\" style=\"top:65px;left:395px;\" src=\"/120/fr/static/_content/33-title-1.png\">\n        <img class=\"abs halfScale 33-sub\" style=\"top:274px;left:426px;\" src=\"/120/fr/static/_content/33-sub-1.png\">\n        <img class=\"abs halfScale 33-line\" style=\"top:271px;left:394px;\" src=\"/120/fr/static/_content/33-line-1.png\">\n        <img id=\"33-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"france-s-borel-estonia-s-lehis-win-qatar-epee-grand-prix\">Grand Prix d'\xE9p\xE9e : le Fran\xE7ais Borel et l'Estonienne Lehis s'emparent de l'or au Qatar</h2>\n        <img src=\"/120/fr/static/_content/33-mobile-1.jpg\">\n        <p><strong>Doha, Qatar<br>28-30 Janvier 2022</strong></p>\n        <p><strong>Le champion du monde fran\xE7ais Yannick Borel et l'Estonienne Katrina Lehis ont remport\xE9 les m\xE9dailles d'or de l'\xE9tape qatarienne du Grand Prix d'\xE9p\xE9e 2022 \xE0 Doha. </strong></p>\n        <p>La comp\xE9tition, organis\xE9e au complexe sportif Aspire Zone/Aspire Dome, a \xE9t\xE9 disput\xE9e par 161 tireurs et 120 tireuses.</p>\n        <p>Borel a battu son co\xE9quipier Aymerick Gally en finale de l'\xE9p\xE9e masculine individuelle sur le score de 15-10. En demi-finale, Gally avait \xE9limin\xE9 l'Italien Federico Vismara (15-6), et Borel avait fait chuter l'Italien Davide Di Veroli (15-9) apr\xE8s avoir sorti en quart de finale le champion olympique fran\xE7ais Romain Cannone (15-5). \xC0 noter \xE9galement la d\xE9faite du champion du monde Gergely Siklosi face \xE0 Di Veroli dans le tableau de 16 (15-12).</p>\n        <p>La finale de l'\xE9p\xE9e f\xE9minine individuelle a \xE9t\xE9 remport\xE9e par Lehis face \xE0 sa co\xE9quipi\xE8re Nelli Differt (15-11). En demi-finale, Differt avait battu une autre de ses co\xE9quipi\xE8res, Erika Kirpu (12-11), et Lehis avait \xE9limin\xE9 sur le fil la Fran\xE7aise Marie-Florence Candassamy (15-14), apr\xE8s avoir vaincu en quart de finale la championne olympique ukrainienne Yana Shemyakina (15-9).</p>\n        <p>Les huit premiers au classement final de l'\xE9p\xE9e masculine sont Yannick Borel (FRA, or), Aymerick Gally (FRA, argent), Davide Di Veroli (ITA, bronze), Federico Vismara (ITA, bronze), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) et Volodymyr Stankevych (UKR).</p>\n        <p>Les huit premi\xE8res au classement final de l'\xE9p\xE9e f\xE9minine sont Katrina Lehis (EST, or), Nelli Differt (EST, argent), Marie-Florence Candassamy (FRA, bronze), Erika Kirpu (EST, bronze), Renata Knapik-Miazga (POL), Irina Embrich (EST), Anna Kun (HUN) et Yana Shemyakina (UKR).</p>\n        <p>Retrouvez tous les r\xE9sultats officiels de la comp\xE9tition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualit\xE9 palpitante de l'escrime mondiale, regardez la cha\xEEneYouTube de la FIE.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim\n            .fromTo(cOf(\"33-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"33-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"33-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"33-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg33Anim.stop();\n          resetNumbers(\"33-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  GRAND PRIX D'ÉPÉE : LE FRANÇAIS BOREL ET L'ESTONIENNE LEHIS S'EMPARENT DE L'OR AU QATAR DOHA, QATAR 28-30 JANVIER 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"34-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim\n            .fromTo(idOf(\"34-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          resetNumbers(\"34-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "GRAND PRIX D'ÉPÉE DOHA, QATAR 2/2  Le champion du monde français Yannick Borel et l'Estonienne Katrina Lehis ont remporté les médailles d'or de l'étape qatarienne du Grand Prix d'épée 2022 à Doha. La compétition, organisée au complexe sportif Aspire Zone/Aspire Dome, a été disputée par 161 tireurs et 120 tireuses. Borel a battu son coéquipier Aymerick Gally en finale de l'épée masculine individuelle sur le score de 15-10. En demi-finale, Gally avait éliminé l'Italien Federico Vismara (156), et Borel avait fait chuter l'Italien Davide Di Veroli (15-9) après avoir sorti en quart de finale le champion olympique français Romain Cannone (15-5). À noter également la défaite du champion du monde Gergely Siklosi face à Di Veroli dans le tableau de 16 (15-12). La finale de l'épée féminine individuelle a été remportée par Lehis face à sa coéquipière Nelli Differt (15-11). En demi-finale, Differt avait battu une autre de ses coéquipières, Erika Kirpu (1211), et Lehis avait éliminé sur le fil la Française Marie-Florence Candassamy (15-14), après avoir vaincu en quart de finale la championne olympique ukrainienne Yana Shemyakina (15-9).  Les huit premiers au classement final de l'épée masculine sont Yannick Borel (FRA, or), Aymerick Gally (FRA, argent), Davide Di Veroli (ITA, bronze), Federico Vismara (ITA, bronze), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) et Volodymyr Stankevych (UKR). Les huit premières au classement final de l'épée féminine sont Katrina Lehis (EST, or), Nelli Differt (EST, argent), Marie-Florence Candassamy (FRA, bronze), Erika Kirpu (EST, bronze), Renata Knapik-Miazga (POL), Irina Embrich (EST), Anna Kun (HUN) et Yana Shemyakina (UKR). Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 35-title\" style=\"top:88px;left:381px;\" src=\"/120/fr/static/_content/35-title-1.png\">\n        <img class=\"abs halfScale 35-sub\" style=\"top:235px;left:410px;\" src=\"/120/fr/static/_content/35-sub-1.png\">\n        <img class=\"abs halfScale 35-line\" style=\"top:232px;left:378px;\" src=\"/120/fr/static/_content/35-line-1.png\">\n        <img id=\"35-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"men-s-and-women-s-epee-grand-prix-in-budapest\">Coupe du monde de sabre masculin : un doubl\xE9 en or pour la Hongrie \xE0 Budapest</h2>\n        <img src=\"/120/fr/static/_content/35-mobile-1.jpg\">\n        <p><strong>Budapest, Hongrie<br>4-6 Mars 2022</strong></p>\n        <p><strong>Le triple champion olympique hongrois Aron Szilagyi a d\xE9croch\xE9 l'or de l'\xE9preuve individuelle de la Coupe du monde de sabre de Budapest, avant de remonter sur la plus haute marche du podium \xE0 l'issue de l'\xE9preuve par \xE9quipes aux c\xF4t\xE9s de ses co\xE9quipiers.</strong></p>\n        <p>La Coupe du monde de sabre individuel \xAB Gerevich-Kov\xE1cs-K\xE1rp\xE1ti \xBB et la Coupe du monde de sabre par \xE9quipes \xAB Zar\xE1ndi Csaba \xBB disput\xE9es \xE0 Budapest ont r\xE9uni 204 tireurs et 23 \xE9quipes au BOK Hall (anciennement SYMA Hall) de la capitale hongroise. </p>\n        <p>Szilagyi a d\xE9croch\xE9 le s\xE9same de l'\xE9preuve individuelle en s'imposant en finale face \xE0 l'Italien Luca Curatoli (15-7). En demi-finale, Curatoli avait \xE9limin\xE9 le champion du monde cor\xE9en Sanguk Oh (15-8), et Szilagyi avait battu sur le fil un autre champion du monde cor\xE9en, Junghwan Kim (15-14).</p>\n        <p>La finale de l'\xE9preuve par \xE9quipes a \xE9t\xE9 remport\xE9e par la Hongrie face \xE0 la France (45-38). En demi-finale, la France avait \xE9limin\xE9 l'Allemagne (45-40), la Hongrie s'imposant quant \xE0 elle face \xE0 la Roumanie (45-30). L'Allemagne est repartie avec la m\xE9daille de bronze au d\xE9triment de la Roumanie (45-43). \n        </p>\n        <p>Les huit premiers au classement final du sabre masculin individuel sont Aron Szilagyi (HUN, or), Luca Curatoli (ITA, argent), Junghwan Kim (KOR, bronze), Sanguk Oh (KOR, bronze), Bolad\xE9 Apithy (FRA), Luigi Samele (ITA), Daryl Homer (USA) et Matyas Szabo (GER). </p>\n        <p>Les huit premi\xE8res nations au classement final du sabre masculin par \xE9quipes sont la Hongrie (or), la France (argent), l'Allemagne (bronze), la Roumanie, la Cor\xE9e, les USA, l'Italie et l'Iran.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim\n            .fromTo(cOf(\"35-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"35-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"35-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"35-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg35Anim.stop();\n          resetNumbers(\"35-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  COUPE DU MONDE DE SABRE MASCULIN : UN DOUBLÉ EN OR POUR LA HONGRIE À BUDAPEST BUDAPEST, HONGRIE 4–6 MARS 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"36-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim\n            .fromTo(idOf(\"36-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          resetNumbers(\"36-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE DE SABRE MASCULIN BUDAPEST, HONGRIE 2/3  Le triple champion olympique hongrois Aron Szilagyi a décroché l'or de l'épreuve individuelle de la Coupe du monde de sabre de Budapest, avant de remonter sur la plus haute marche du podium à l'issue de l'épreuve par équipes aux côtés de ses coéquipiers. La Coupe du monde de sabre individuel « Gerevich-Kovács-Kárpáti » et la Coupe du monde de sabre par équipes « Zarándi Csaba » disputées à Budapest ont réuni 204 tireurs et 23 équipes au BOK Hall (anciennement SYMA Hall) de la capitale hongroise.  Szilagyi a décroché le sésame de l'épreuve individuelle en s'imposant en finale face à l'Italien Luca Curatoli (15-7). En demi-finale, Curatoli avait éliminé le champion du monde coréen Sanguk Oh (15-8), et Szilagyi avait battu sur le fil un autre champion du monde coréen, Junghwan Kim (15-14). La finale de l'épreuve par équipes a été remportée par la Hongrie face à la France (4538). En demi-finale, la France avait éliminé l'Allemagne (45-40), la Hongrie s'imposant quant à elle face à la Roumanie (45-30). L'Allemagne est repartie avec la médaille de bronze au détriment de la Roumanie (45-43)."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <!-- <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 624px; right: 156px; width: 114px; height: 20px; \"></div>\n        </a> -->\n        \n        <!-- <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 577px; right: 152px; width: 111px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 554px; right: 388px; width: 139px; height: 20px;\"></div>\n        </a> -->\n\n        <img id=\"37-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim\n            .fromTo(idOf(\"37-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop();\n          resetNumbers(\"37-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COUPE DU MONDE DE SABRE MASCULIN BUDAPEST, HONGRIE 3/3  Les huit premiers au classement final du sabre masculin individuel sont Aron Szilagyi (HUN, or), Luca Curatoli (ITA, argent), Junghwan Kim (KOR, bronze), Sanguk Oh (KOR, bronze), Boladé Apithy (FRA), Luigi Samele (ITA), Daryl Homer (USA) et Matyas Szabo (GER).  Les huit premières nations au classement final du sabre masculin par équipes sont la Hongrie (or), la France (argent), l'Allemagne (bronze), la Roumanie, la Corée, les USA, l'Italie et l'Iran. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/fr/static/_content/38-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 39-title\" style=\"top:75px;left:64px;\" src=\"/120/fr/static/_content/39-title-1.png\">\n        <img class=\"abs halfScale 39-sub\" style=\"top:220px;left:97px;\" src=\"/120/fr/static/_content/39-sub-1.png\">\n        <img class=\"abs halfScale 39-line\" style=\"top:223px;left:64px;\" src=\"/120/fr/static/_content/39-line-1.png\">\n        <img id=\"39-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"a-grand-and-successful-2022-junior-and-cadet-fencing-world-championships-in-dubai\">Les Championnats du monde d'escrime juniors et cadets 2022 aussi grandioses que r\xE9ussis \xE0 Duba\xEF </h2>\n        <img src=\"/120/fr/static/_content/39-mobile-1.jpg\">\n        <p><strong>Duba\xEF, \xC9mirats arabes unis<br>2 au 10 avril 2022</strong></p>\n        <p><strong>Les Championnats du monde d'escrime juniors et cadets 2022 ont \xE9t\xE9 qualifi\xE9s de \xAB succ\xE8s spectaculaire \xBB par le pr\xE9sident int\xE9rimaire de la FIE, Emmanuel Katsiadakis. </strong></p>\n        <p>La comp\xE9tition, qui se d\xE9roulait sur neuf jours et comptait 18 \xE9preuves individuelles et par \xE9quipes pour les tireurs et tireuses juniors et cadets, a enregistr\xE9 le plus grand nombre de participants de son histoire, avec 1 357 escrimeurs en lice venus de 103 pays. Les championnats ont \xE9t\xE9 organis\xE9s dans l'impressionnant Complexe sportif Hamdan de Duba\xEF, un complexe multisports de calibre mondial connu pour avoir accueilli un grand nombre de championnats et \xE9v\xE9nements internationaux. </p>\n        <p>Le tableau suivant r\xE9capitule le nombre de pays ayant particip\xE9 aux Championnats du monde d'escrime juniors et cadets, par r\xE9gions continentales :</p>\n        <ul>\n          <li>\n            Afrique 13</li>\n          <li>\n            Am\xE9riques 20</li>\n          <li>\n            Asie/Oc\xE9anie 32</li>\n          <li>\n            Europe 38</li>\n          <li>\n            Total 103 </li>\n          </ul>\n          <p>La c\xE9r\xE9monie d'ouverture officielle des championnats s'\xE9tait d\xE9roul\xE9e en pr\xE9sence de plusieurs dignitaires locaux : Son Excellence Dr. Ahmad bin Abdullah Humaid Belhoul Al Falasi, Ministre d'\xC9tat en charge de l'Entreprenariat et des PME, et Pr\xE9sident du Conseil d'administration de l'Autorit\xE9 sportive g\xE9n\xE9rale ; Son Excellence Sheikh Salem bin Sultan Al Qasimi, membre du Comit\xE9 ex\xE9cutif de la FIE, pr\xE9sident de la Conf\xE9d\xE9ration asiatique d'escrime, pr\xE9sident de la F\xE9d\xE9ration arabe d'escrime et pr\xE9sident de la F\xE9d\xE9ration d'escrime des EAU ; Son Excellence Saeed Hareb, secr\xE9taire g\xE9n\xE9ral du Comit\xE9 sportif de Duba\xEF ; et Son Excellence Nasser Al Rahma, vice-pr\xE9sident du complexe sportif de Hamdan. Les championnats ont \xE9t\xE9 d\xE9clar\xE9s officiellement ouverts par le Pr\xE9sident int\xE9rimaire de la FIE, Emmanuel Katsiadakis. </p>\n          <p>Trois jours de comp\xE9tition cons\xE9cutifs ont \xE9t\xE9 consacr\xE9s \xE0 chaque arme (sabre, fleuret, \xE9p\xE9e). Chaque cycle de trois jours incluait les \xE9preuves masculines et f\xE9minines individuelles juniors le premier jour, les \xE9preuves individuelles cadets le deuxi\xE8me jour et les \xE9preuves par \xE9quipes juniors le dernier jour. </p>\n          <p>Les protocoles COVID-19 ont \xE9t\xE9 respect\xE9s pendant les Championnats afin de garantir la s\xE9curit\xE9 de tous les participants et des personnes pr\xE9sentes, avec notamment le port du masque, le respect des mesures de distanciation sociale et des tests r\xE9guliers. \n            Les huit premiers au classement g\xE9n\xE9ral des diff\xE9rentes \xE9preuves sont les suivants :</p>\n          <p>Sabre</p>\n          <ul>\n            <li>\n              Sabre masculin individuel junior (152 tireurs)<ol>\n                <li>\n                  Colin Heathcock (GER, or)</li>\n                <li>\n                  Pietro Torre (ITA, argent)</li>\n                <li>\n                  Antonio Heathcock (GER, bronze)</li>\n                <li>\n                  Heegeun Hwang (KOR, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sabre f\xE9minin individuel junior (126 tireuses)<ol>\n                <li>\n                  Magda Skarbonkiewicz (USA, or)</li>\n                <li>\n                  Honor Johnson (USA, argent)</li>\n                <li>\n                  Zaynab Dayibekova (UZB, bronze)</li>\n                <li>\n                  Sugar Katinka Battai (HUN, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sabre masculin individuel cadet (95 tireurs)<ol>\n                <li>\n                  Zuhridden Kodirov (UZB, or)</li>\n                <li>\n                  Colin Heathcock (GER, argent)</li>\n                <li>\n                  Cody Ji (USA, bronze)</li>\n                <li>\n                  William Morrill (USA, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sabre f\xE9minin individuel cadet (90 tireuses)<ol>\n                <li>\n                  Magda Skarbonkiewicz (USA, or)</li>\n                <li>\n                  Siobhan Sullivan (USA, argent)</li>\n                <li>\n                  Alejandra Manga (FRA, bronze)</li>\n                <li>\n                  Eunyu Kim (KOR, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sabre masculin par \xE9quipes junior (34 \xE9quipes)<ol>\n                <li>\n                  Italie (or)</li>\n                <li>\n                  Roumanie (argent)</li>\n                <li>\n                  \xC9gypte (bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sabre f\xE9minin par \xE9quipes junior (27 \xE9quipes)<ol>\n                <li>\n                  France (or)</li>\n                <li>\n                  Hongrie (argent)</li>\n                <li>\n                  Italie (bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <p>FLEURET</p>\n          <ul>\n            <li>\n              Fleuret masculin individuel junior (180 tireurs)<ol>\n                <li>\n                  Kazuki Iimura (JPN, or)</li>\n                <li>\n                  Hyeonbhin An (KOR, argent)</li>\n                <li>\n                  Anas Anane (FRA, bronze)</li>\n                <li>\n                  Chase T. Emmer (USA, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Fleuret f\xE9minin individuel junior (148 tireuses)<ol>\n                <li>\n                  Lauren Scruggs (USA, or)</li>\n                <li>\n                  Yuzuha Takeyama (JPN, argent)</li>\n                <li>\n                  Carolina Stutchbury (GBR, bronze)</li>\n                <li>\n                  Kateryna Budenko (UKR, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Fleuret masculin individuel cadet (117 tireurs)<ol>\n                <li>\n                  Tit Nam Cheng (HKG, or)</li>\n                <li>\n                  Ruben Lindner (GER, argent)</li>\n                <li>\n                  Matteo Iacomoni (ITA, bronze)</li>\n                <li>\n                  Andrew Chen (USA, bronze)</li>\n              </ol>\n            </li>\n            <li>\n              Fleuret f\xE9minin individuel cadet (104 tireuses)<ol>\n                <li>\n                  Jessica Zi Jia Guo (CAN, or)</li>\n                <li>\n                  Carolina Stutchbury (GBR, argent)</li>\n                <li>\n                  Rino Nagase (JPN, bronze)</li>\n                <li>\n                  Matilde Molinari (ITA, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Fleuret masculin par \xE9quipes junior (37 \xE9quipes)<ol>\n                <li>\n                  Italie (or)</li>\n                <li>\n                  France (argent)</li>\n                <li>\n                  Hongrie (bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Fleuret f\xE9minin par \xE9quipes junior (32 \xE9quipes)<ol>\n                <li>\n                  USA (or)</li>\n                <li>\n                  Italie (argent)</li>\n                <li>\n                  Japon (bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <p>\xC9p\xE9e </p>\n          <ul>\n            <li>\n              \xC9p\xE9e masculine individuelle junior (208 tireurs)<ol>\n                <li>\n                  Zsombor Keszthelyi (HUN, or)</li>\n                <li>\n                  Mohamed Yasseen (EGY, argent)</li>\n                <li>\n                  James Jeal (GBR, bronze)</li>\n                <li>\n                  Lino Heurlin Vazquez (FRA, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              \xC9p\xE9e f\xE9minine individuelle junior (160 tireuses)<ol>\n                <li>\n                  Hadley Husisian (USA, or)</li>\n                <li>\n                  Nicole Feygin (ISR, argent)</li>\n                <li>\n                  Aleyna Erturk (TUR, bronze)</li>\n                <li>\n                  Ketki Ketkar (USA, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              \xC9p\xE9e masculine individuelle cadet (142 tireurs)<ol>\n                <li>\n                  Samuel Imrek (USA, or)</li>\n                <li>\n                  Alon Sarid (ISR, argent)</li>\n                <li>\n                  Fabio Mastromarino (ITA, bronze)</li>\n                <li>\n                  Maksym Perchuk (UKR, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              \xC9p\xE9e f\xE9minine individuelle cadet (109 tireuses)<ol>\n                <li>\n                  Aleyna Erturk (TUR, or)</li>\n                <li>\n                  Anna Maksymenko (UKR, argent)</li>\n                <li>\n                  Hailin Chen (HKG, bronze)</li>\n                <li>\n                  Mizuki Homma (JPN, bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              \xC9p\xE9e masculine par \xE9quipes junior (42 \xE9quipes)<ol>\n                <li>\n                  \xC9gypte (or)</li>\n                <li>\n                  \xC9tats-Unis (argent)</li>\n                <li>\n                  France (bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              \xC9p\xE9e f\xE9minine par \xE9quipes junior (33 \xE9quipes)<ol>\n                <li>\n                  Isra\xEBl (or)</li>\n                <li>\n                  Pologne (argent)</li>\n                <li>\n                  \xC9tats-Unis (bronze)</li>\n              </ol>\n            </li>\n          </ul>\n          <p>Tableau complet des m\xE9dailles</p>\n          <ol>\n            <li>\n              USA - 6 OR, 3 argent, 6 Bronze - 15 Total</li>\n            <li>\n              ITA - 2 OR, 2 argent, 4 Bronze - 8 Total</li>\n            <li>\n              GER - 1 OR, 2 argent, 1 Bronze - 4 Total</li>\n            <li>\n              ISR - 1 OR, 2 argent, 0 Bronze - 3 Total</li>\n            <li>\n              FRA - 1 OR, 1 argent, 4 Bronze - 6 Total</li>\n            <li>\n              JPN - 1 OR, 1 argent, 3 Bronze - 5 Total</li>\n            <li>\n              HUN - 1 OR, 1 argent, 2 Bronze - 4 Total</li>\n            <li>\n              EGY - 1 OR, 1 argent, 1 Bronze - 3 Total</li>\n            <li>\n              TUR - 1 OR, 0 argent, 1 Bronze - 2 Total</li>\n            <li>\n              HKG - 1 OR, 0 argent, 1 Bronze - 2 Total</li>\n            <li>\n              UZB - 1 OR, 0 argent, 1 Bronze - 2 Total</li>\n            <li>\n              CAN - 1 OR, 0 argent, 0 Bronze - 1 Total</li>\n            <li>\n              UKR - 0 OR, 1 argent, 2 Bronze - 3 Total</li>\n            <li>\n              GBR - 0 OR, 1 argent, 2 Bronze - 3 Total</li>\n            <li>\n              KOR - 0 OR, 1 argent, 2 Bronze - 3 Total</li>\n            <li>\n              POL - 0 OR, 1 argent, 0 Bronze - 1 Total</li>\n            <li>\n              ROU - 0 OR, 1 argent, 0 Bronze - 1 Total</li>\n          </ol>\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim\n            .fromTo(cOf(\"39-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"39-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"39-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"39-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg39Anim.stop();\n          resetNumbers(\"39-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS 2022 AUSSI GRANDIOSES QUE RÉUSSIS À DUBAÏ DUBAÏ, ÉMIRATS ARABES UNIS 2 AU 10 AVRIL 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"40-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim\n            .fromTo(idOf(\"40-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          resetNumbers(\"40-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS DUBAÏ, ÉMIRATS ARABES UNIS 2/5  Les Championnats du monde d'escrime juniors et cadets 2022 ont été qualifiés de « succès spectaculaire » par le président intérimaire de la FIE, Emmanuel Katsiadakis. La compétition, qui se déroulait sur neuf jours et comptait 18 épreuves individuelles et par équipes pour les tireurs et tireuses juniors et cadets, a enregistré le plus grand nombre de participants de son histoire, avec 1 357 escrimeurs en lice venus de 103 pays. Les championnats ont été organisés dans l'impressionnant Complexe sportif Hamdan de Dubaï, un complexe multisports de calibre mondial connu pour avoir accueilli un grand nombre de championnats et événements internationaux.  Le tableau suivant récapitule le nombre de pays ayant participé aux Championnats du monde d'escrime juniors et cadets, par régions continentales : Afrique			13 Amériques		 20 Asie/Océanie 32 Europe			38 Total			103 La cérémonie d'ouverture officielle des championnats s'était déroulée en présence de plusieurs dignitaires locaux : Son Excellence Dr. Ahmad bin Abdullah Humaid Belhoul Al Falasi, Ministre d'État en charge de l'Entreprenariat et des PME, et Président du Conseil d'administration de l'Autorité sportive générale ; Son Excellence Sheikh Salem bin Sultan Al Qasimi, membre du Comité exécutif de la FIE, président de la"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"41-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim\n            .fromTo(idOf(\"41-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n          resetNumbers(\"41-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS DUBAÏ, ÉMIRATS ARABES UNIS 3/5  Confédération asiatique d'escrime, président de la Fédération arabe d'escrime et président de la Fédération d'escrime des EAU ; Son Excellence Saeed Hareb, secrétaire général du Comité sportif de Dubaï ; et Son Excellence Nasser Al Rahma, vice-président du complexe sportif de Hamdan. Les championnats ont été déclarés officiellement ouverts par le Président intérimaire de la FIE, Emmanuel Katsiadakis. Trois jours de compétition consécutifs ont été consacrés à chaque arme (sabre, fleuret, épée). Chaque cycle de trois jours incluait les épreuves masculines et féminines individuelles juniors le premier jour, les épreuves individuelles cadets le deuxième jour et les épreuves par équipes juniors le dernier jour. Les protocoles COVID-19 ont été respectés pendant les Championnats afin de garantir la sécurité de tous les participants et des personnes présentes, avec notamment le port du masque, le respect des mesures de distanciation sociale et des tests réguliers. Les huit premiers au classement général des différentes épreuves sont les suivants :  SABRE • Sabre masculin individuel junior (152 tireurs) 1. Colin Heathcock (GER, or) 2. Pietro Torre (ITA, argent) 3. Antonio Heathcock (GER, bronze) 3. Heegeun Hwang (KOR, bronze) • Sabre féminin individuel junior (126 tireuses) 1. Magda Skarbonkiewicz (USA, or) 2. Honor Johnson (USA, argent) 3. Zaynab Dayibekova (UZB, bronze) 3. Sugar Katinka Battai (HUN, bronze)  • Sabre masculin individuel cadet (95 tireurs) 1. Zuhridden Kodirov (UZB, or) 2. Colin Heathcock (GER, argent) 3. Cody Ji (USA, bronze) 3. William Morrill (USA, bronze)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"42-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim\n            .fromTo(idOf(\"42-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n          resetNumbers(\"42-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS DUBAÏ, ÉMIRATS ARABES UNIS 4/5  FLEURET •F  leuret masculin individuel junior (180 tireurs) 1. Kazuki Iimura (JPN, or) 2. Hyeonbhin An (KOR, argent) 3. Anas Anane (FRA, bronze) 3. Chase T. Emmer (USA, bronze)  • Sabre féminin individuel cadet (90 tireuses) 1. Magda Skarbonkiewicz (USA, or) 2. Siobhan Sullivan (USA, argent) 3. Alejandra Manga (FRA, bronze) 3. Eunyu Kim (KOR, bronze) •S  abre masculin par équipes junior (34 équipes) 1. Italie (or) 2. Roumanie (argent) 3. Égypte (bronze) • Sabre féminin par équipes junior (27 équipes) 1. France (or) 2. Hongrie (argent) 3. Italie (bronze)  • Fleuret féminin individuel junior (148 tireuses) 1. Lauren Scruggs (USA, or) 2. Yuzuha Takeyama (JPN, argent) 3. Carolina Stutchbury (GBR, bronze) 3. Kateryna Budenko (UKR, bronze) •F  leuret masculin individuel cadet (117 tireurs) 1. Tit Nam Cheng (HKG, or) 2. Ruben Lindner (GER, argent) 3. Matteo Iacomoni (ITA, bronze) 3. Andrew Chen (USA, bronze) • Fleuret féminin individuel cadet (104 tireuses) 1. Jessica Zi Jia Guo (CAN, or) 2. Carolina Stutchbury (GBR, argent) 3. Rino Nagase (JPN, bronze) 3. Matilde Molinari (ITA, bronze)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-red.png\">\n        </a>\n          \n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:655px;left:45px\" onclick=\"showOverlay('43-popups')\"\n          src=\"/120/fr/static/_content/trophy-red.png\">\n        \n        <img id=\"43-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div id=\"43-popups\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img src=\"/120/fr/static/_content/39-popup-1.png\" style=\"transform: scale(0.873); transform-origin: top left;\">\n          <div class=\"contentLink\" style=\"top: 55px; left: 1015px; width: 35px; height: 35px;\" onclick=\"hideOverlay('43-popups');\"></div>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim\n            .fromTo(idOf(\"43-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n          resetNumbers(\"43-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS DUBAÏ, ÉMIRATS ARABES UNIS 5/5  • Fleuret masculin par équipes junior (37 équipes) 1. Italie (or) 2. France (argent) 3. Hongrie (bronze) • Fleuret féminin par équipes junior (32 équipes) 1. USA (or) 2. Italie (argent) 3. Japon (bronze) ÉPÉE •É  pée masculine individuelle junior (208 tireurs) 1. Zsombor Keszthelyi (HUN, or) 2. Mohamed Yasseen (EGY, argent) 3. James Jeal (GBR, bronze) 3. Lino Heurlin Vazquez (FRA, bronze)  Tableau complet des médailles  • Épée féminine individuelle junior (160 tireuses) 1. Hadley Husisian (USA, or) 2. Nicole Feygin (ISR, argent) 3. Aleyna Erturk (TUR, bronze) 3. Ketki Ketkar (USA, bronze)  •É  pée masculine individuelle cadet (142 tireurs) 1. Samuel Imrek (USA, or) 2. Alon Sarid (ISR, argent) 3. Fabio Mastromarino (ITA, bronze) 3. Maksym Perchuk (UKR, bronze) • Épée féminine individuelle cadet (109 tireuses) 1. Aleyna Erturk (TUR, or) 2. Anna Maksymenko (UKR, argent) 3. Hailin Chen (HKG, bronze) 3. Mizuki Homma (JPN, bronze) • Épée masculine par équipes junior (42 équipes) 1. Égypte (or) 2. États-Unis (argent) 3. France (bronze) • Épée féminine par équipes junior (33 équipes) 1. Israël (or) 2. Pologne (argent) 3. États-Unis (bronze) W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:service@blue-gauntletservice.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 277px; right: 647px; width: 175px; height: 21px;\"></div>\n        </a>\n        <!-- <a href=\"mailto:service@blue-gauntletservice.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 201px; right: 697px; width: 265px; height: 21px;\"></div>\n        </a> -->\n        <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 255px; right: 685px; width: 135px; height: 21px;\"></div>\n        </a>\n        <!-- <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 157px; right: 751px; width: 209px; height: 38px;\"></div>\n        </a> -->\n      ",
    "mobileHtml": "\n        <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/44-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 45-title\" style=\"top:44px;left:61px;\" src=\"/120/fr/static/_content/45-title-1.png\">\n\n        <img id=\"45-next\" class=\"halfScale pointer\" style=\"top:718px;right:-243px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-long-pink.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n        \n        <div class=\"contentLink\" onclick=\"showOverlay('45-popups')\" style=\"    bottom: 413px; right: 161px; width: 40px; height: 33px;\"></div>\n\n        <div id=\"45-popups\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"45-pop-1\" class=\"halfScale 45-popup\" src=\"/120/fr/static/_content/45-popup-1.png\" alt=\"\">\n          <img id=\"45-pop-2\" class=\"halfScale 45-popup\" src=\"/120/fr/static/_content/45-popup-2.png\" style=\"opacity:0\" alt=\"\">\n          <div class=\"contentLink\" style=\"top:721px;left:600px;width:138px;height:48px;\"\n            onclick=\"togglePage45('45-pop-1', '45-popup');\"></div>\n          <div class=\"contentLink\" style=\"top:721px;left:738px;width:138px;height:48px;\"\n            onclick=\"togglePage45('45-pop-2', '45-popup');\"></div>\n          <div class=\"contentLink\" style=\"top: 40px; left: 1019px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('45-popups');\"></div>\n        </div>\n      ",
    "mobileHtml": "\n        <h2\n          id=\"bert-m-j-van-de-flier-ned-mh-given-royal-decoration-from-the-netherlands\">\n          Bert M.J. van de Flier (NED, MH) re\xE7oit une d\xE9coration royale des Pays-Bas\n        </h2>\n        <img src=\"/120/fr/static/_content/45-mobile-1.jpg\">\n        <p><strong>Lausanne, Suisse<br>6 d\xE9cembre 2021</strong></p>\n        <p><strong>La FIE a eu le plaisir d'apprendre qu'un de ses Membres d'Honneur et Membres du Conseil du Fair Play de la FIE, Bert M. J. van der Flier (NED), a re\xE7u une d\xE9coration royale, celle d'\xAB Officier de l'ordre d'Orange-Nassau \xBB, de son Excellence Pieter de Gooijer, ambassadeur des Pays-Bas en France. La c\xE9r\xE9monie s'est d\xE9roul\xE9e en pr\xE9sence de M. Dominique Breton, consul honoraire \xE0 Brest ; M. Guy Pennec, maire de Plourin-l\xE8s-Morlaix ; et Leon Pijnappel, pr\xE9sident de la f\xE9d\xE9ration royale n\xE9erlandaise d'escrime (KNAS). </strong></p>\n        <p>Cette d\xE9coration, dont le grade est sup\xE9rieur \xE0 celui de chevalier, est l'une des distinctions les plus importantes pouvant \xEAtre d\xE9cern\xE9es \xE0 un civil par les Pays-Bas, et lui a \xE9t\xE9 remise en reconnaissance de ses nombreuses ann\xE9es de service et de d\xE9vouement \xE0 l'escrime n\xE9erlandaise, europ\xE9enne et mondiale. Pendant de nombreuses ann\xE9es, M. van de Flier a en effet assum\xE9 diff\xE9rentes fonctions au sein de la famille de l\u2019escrime, et obtenu des r\xE9sultats qui ont motiv\xE9 cette distinction.</p>\n        <p>M. van de Flier a \xE9t\xE9 nomm\xE9 Membre d'honneur de la FIE par le Congr\xE8s 2013 \xE0 Paris, et intronis\xE9 au Hall of Fame de la FIE en 2014. Il a \xE9t\xE9 membre de la Commission d'\xE9chelle des votes de la FIE, du Panel disciplinaire, et il a \xE9galement pr\xE9sid\xE9 le Conseil du Fair Play de la FIE. Il a \xE9t\xE9 pr\xE9sident du DT lors des Championnats du monde, et a assum\xE9 \xE0 plusieurs reprises la fonction de superviseur officiel lors de comp\xE9titions de la Coupe du monde de la FIE.</p>\n        <p>Depuis 2012, M. van de Flier travaille au Comit\xE9 international du Fair Play (CIFP), dont il est le secr\xE9taire-tr\xE9sorier depuis 2015. Son travail a abouti en 2017 \xE0 la cr\xE9ation du Conseil du Fair Play de la FIE.</p>\n        <p>M. van de Flier est \xE9galement Membre d'Honneur de la KNAS depuis 1995, et s'implique activement dans l'organisation depuis 1978. Il a pr\xE9sid\xE9 sa Commission technique avant de devenir son secr\xE9taire g\xE9n\xE9ral en 1981 et son pr\xE9sident int\xE9rimaire en 1982. Il est ensuite devenu le plus jeune pr\xE9sident de la KNAS, une fonction qu'il a assum\xE9e pendant 12 ans. Apr\xE8s avoir quitt\xE9 le conseil d'administration en 1995, il est revenu au sein de la f\xE9d\xE9ration en 2010 comme secr\xE9taire g\xE9n\xE9ral, un poste qu'il occupe encore aujourd'hui. </p>\n        <p>Il a contribu\xE9 \xE0 la cr\xE9ation de la Conf\xE9d\xE9ration europ\xE9enne d'escrime en 1991, et a si\xE9g\xE9 \xE0 son conseil d'administration pendant 17 ans, en tant que secr\xE9taire g\xE9n\xE9ral, premier vice-pr\xE9sident, tr\xE9sorier et pr\xE9sident de la Commission SEMI. Plusieurs championnats du monde et d'Europe ont \xE9t\xE9 organis\xE9s aux Pays-Bas entre 1985 et 1995 gr\xE2ce aux efforts de M. van de Flier, qui a \xE9galement jou\xE9 un r\xF4le fondamental pour que le \xAB Airborne Trophy \xBB et le \xAB Zoetermeer Trophy \xBB deviennent (auparavant) des comp\xE9titions de la Coupe du monde de la FIE aux Pays-Bas.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim\n            .fromTo(cOf(\"45-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"45-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        function togglePage45(show, hide) {\n          var show = idOf(show)\n          var hide = cOf(hide)\n          TweenMax.to(hide, 0.01, {opacity: 0});\n          TweenMax.to(show, 0.01, {opacity:1});\n        }\n        function onPageLeave() {\n          pg45Anim.stop();\n          resetNumbers(\"45-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACTUALITÉS DE L A FIE  ACTUALITÉS DE LA FIE Bert M.J. van de Flier (NED, MH) reçoit une décoration royale des Pays-Bas Voir plus ici.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n      <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n        <div class=\"contentLinkNone\" style=\"bottom: 259px; right: 22px; width: 33px; height: 154px;\"></div>\n      </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/46-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 47-title\" style=\"top:106px;left:65px;\" src=\"/120/fr/static/_content/47-title-1.png\">\n        <img class=\"abs halfScale 47-sub\" style=\"top:421px;left:92px;\" src=\"/120/fr/static/_content/47-sub-1.png\">\n        <img class=\"abs halfScale 47-line\" style=\"top:424px;left:64px;\" src=\"/120/fr/static/_content/47-line-1.png\">\n        <img id=\"47-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-green.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"togo-hosts-fencing-equipment-repair-course\">Le Togo accueille une formation sur la r\xE9paration des \xE9quipements d'escrime </h2>\n        <img src=\"/120/fr/static/_content/47-mobile-1.jpg\">\n        <p><strong>Lom\xE9, Togo, <br>14 janvier 2022</strong></p>\n        <p><strong>La F\xE9d\xE9ration togolaise d'escrime a accueilli une formation sur la r\xE9paration des \xE9quipements d'escrime du 14 au 18 d\xE9cembre 2021.</strong></p>\n        <p>Les participants, au nombre de 14, appartenaient aux quatre ligues d'escrime de la r\xE9gion. La formation, organis\xE9e \xE0 la demande du pr\xE9sident de la f\xE9d\xE9ration, Victor Lam\xE9ga, a \xE9t\xE9 financ\xE9e par la FIE, qui a \xE9galement d\xE9p\xEAch\xE9 un expert et fourni du mat\xE9riel et des outils.  M. Gilles Martinage (FRA), qui a travaill\xE9 comme armurier officiel et administr\xE9 le contr\xF4le des armes lors de nombreuses comp\xE9titions aux quatre coins du monde, a dirig\xE9 la pr\xE9paration et la formation. </p>\n        <p>Les 14 participants, qui poss\xE9daient des niveaux d'exp\xE9rience vari\xE9s, \xE9taient des athl\xE8tes, des entra\xEEneurs, des ma\xEEtres d'armes form\xE9s \xE0 Dakar ou \xE0 Alger, ou encore des athl\xE8tes en formation pour devenir entra\xEEneurs. M. Koffi Kassefon, arbitre international et directeur technique de la f\xE9d\xE9ration togolaise, a \xE9galement suivi le programme. </p>\n        <p>Le contenu th\xE9orique et informatif de la formation portait sur les syst\xE8mes de notation \xE9lectriques, les aspects techniques du fonctionnement des armes et le r\xE8glement du mat\xE9riel en vigueur. Les th\xE8mes abord\xE9s incluaient la d\xE9tection des d\xE9faillances, la r\xE9paration et le montage complet des armes, la v\xE9rification de l'installation des pistes et le contr\xF4le appropri\xE9 de son \xE9quipement personnel (par ex. lames, fils de corps, masques, etc.). </p>\n        <p>La formation, qui \xE9tait interactive et comprenait des exercices pratiques, visait \xE0 perfectionner et \xE0 mettre en pratique les comp\xE9tences techniques des participants. Son contenu journalier \xE9tait adapt\xE9 aux int\xE9r\xEAts personnels et aux comp\xE9tences et attentes des participants, afin que chacun puisse reproduire de mani\xE8re syst\xE9matique les techniques apprises. Des exercices pratiques ont \xE9t\xE9 r\xE9alis\xE9s \xE0 l'aide du mat\xE9riel fourni par la FIE : 12 kits de r\xE9paration de base, trois sacs d'armurier et un kit sp\xE9cial de r\xE9paration d'enrouleurs de c\xE2ble. L'objectif de ces exercices \xE9taient de reconditionner efficacement les armes de comp\xE9tition, normaliser les fils de corps, r\xE9parer les enrouleurs, g\xE9rer les c\xE2bles de piste et r\xE9parer/g\xE9rer l'appareil de notation et les t\xE9l\xE9commandes associ\xE9es. Les participants ont appris \xE0 tester l'ensemble des \xE9quipements, \xE0 tester et \xE0 d\xE9tecter les d\xE9faillances, et \xE0 identifier et r\xE9aliser les r\xE9parations correctes n\xE9cessaires, notamment souder, coller les fils aux lames et r\xE9fectionner les filets m\xE9talliques pour obtenir une bonne conductivit\xE9. </p>\n        <p>\xC0 l'issue de la formation, les participants \xE9taient notamment capables d'\xE9valuer et de r\xE9parer efficacement presque toutes les armes de comp\xE9tition de la FIE, de tester et de r\xE9parer les fils de corps et les enrouleurs de c\xE2ble, et de r\xE9parer les t\xE9l\xE9commandes des syst\xE8mes de notation ainsi que les c\xE2bles con\xE7us pour connecter les enrouleurs de c\xE2ble aux armes. </p>\n        <p>Les participants ont re\xE7u des certificats de pr\xE9sence. M. Martinage a salu\xE9 leur enthousiasme, leur remarquable travail et leur s\xE9rieux tout au long de la formation. Le pr\xE9sident de la f\xE9d\xE9ration togolaise, M. Lam\xE9ga, s'est \xE9galement f\xE9licit\xE9 de \xAB l'esprit de coh\xE9sion \xBB qui r\xE9gnait pendant le programme.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim\n            .fromTo(cOf(\"47-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"47-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"47-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"47-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg47Anim.stop();\n          resetNumbers(\"47-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACTUALITÉS DES C ONFÉDÉR ATIONS E T DES FÉDÉR ATIONS NATIONALES  LE TOGO ACCUEILLE UNE FORMATION SUR LA RÉPARATION DES ÉQUIPEMENTS D'ESCRIME LOMÉ, TOGO, 14 JANVIER 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-green.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-green.png\">\n        </a>\n\n        <img id=\"48-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-edge-green.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim\n            .fromTo(idOf(\"48-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n          resetNumbers(\"48-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONALES 2/3  La Fédération togolaise d'escrime a accueilli une formation sur la réparation des équipements d'escrime du 14 au 18 décembre 2021. Les participants, au nombre de 14, appartenaient aux quatre ligues d'escrime de la région. La formation, organisée à la demande du président de la fédération, Victor Laméga, a été financée par la FIE, qui a également dépêché un expert et fourni du matériel et des outils. M. Gilles Martinage (FRA), qui a travaillé comme armurier officiel et administré le contrôle des armes lors de nombreuses compétitions aux quatre coins du monde, a dirigé la préparation et la formation.  Les 14 participants, qui possédaient des niveaux d'expérience variés, étaient des athlètes, des entraîneurs, des maîtres d'armes formés à Dakar ou à Alger, ou encore des athlètes en formation pour devenir entraîneurs. M. Koffi Kassefon, arbitre international et directeur technique de la fédération togolaise, a également suivi le programme. Le contenu théorique et informatif de la formation portait sur les systèmes de notation électriques, les aspects techniques du fonctionnement des armes et le règlement du matériel en vigueur. Les thèmes abordés incluaient la détection des défaillances, la réparation et le montage complet des armes, la vérification de l'installation des pistes et le contrôle approprié de son équipement personnel (par ex. lames, fils de corps, masques, etc.). La formation, qui était interactive et comprenait des exercices pratiques, visait à perfectionner et à mettre en pratique les compétences techniques des participants. Son contenu journalier était adapté aux intérêts personnels et aux compétences et attentes des participants,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/fr/static/_content/tw-green.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/fr/static/_content/fb-green.png\">\n        </a>\n\n        <img id=\"49-next\" class=\"halfScale pointer\" style=\"top:647px;right:-79px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-pad-green.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim\n            .fromTo(idOf(\"49-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n          resetNumbers(\"49-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "l'ensemble des équipements, à tester et à détecter les défaillances, et à identifier et réaliser les réparations correctes nécessaires, notamment souder, coller les fils aux lames et réfectionner les filets métalliques pour obtenir une bonne conductivité.  ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONALES 3/3  afin que chacun puisse reproduire de manière systématique les techniques apprises. Des exercices pratiques ont été réalisés à l'aide du matériel fourni par la FIE : 12 kits de réparation de base, trois sacs d'armurier et un kit spécial de réparation d'enrouleurs de câble. L'objectif de ces exercices étaient de reconditionner efficacement les armes de compétition, normaliser les fils de corps, réparer les enrouleurs, gérer les câbles de piste et réparer/ gérer l'appareil de notation et les télécommandes associées. Les participants ont appris à tester  À l'issue de la formation, les participants étaient notamment capables d'évaluer et de réparer efficacement presque toutes les armes de compétition de la FIE, de tester et de réparer les fils de corps et les enrouleurs de câble, et de réparer les télécommandes des systèmes de notation ainsi que les câbles conçus pour connecter les enrouleurs de câble aux armes. Les participants ont reçu des certificats de présence. M. Martinage a salué leur enthousiasme, leur remarquable travail et leur sérieux tout au long de la formation. Le président de la fédération togolaise, M. Laméga, s'est également félicité de « l'esprit de cohésion » qui régnait pendant le programme. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/fr/static/_content/50-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 51-title\" style=\"top:99px;left:66px;\" src=\"/120/fr/static/_content/51-title-1.png\">\n\n        <img id=\"51-next\" class=\"halfScale pointer\" style=\"top:718px;right:-243px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-long-orange.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div class=\"contentLink\" onclick=\"showOverlay('51-popups-1')\" style=\"bottom: 242px; right: 878px; width: 42px; height: 27px;\"></div>\n        <div class=\"contentLink\" onclick=\"showOverlay('51-popups-2')\" style=\"bottom: 472px; right: 314px; width: 31px; height: 23px;\"></div>\n\n        <div id=\"51-popups-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"51-pop-2-1\" class=\"halfScale 51-popup-2\" src=\"/120/fr/static/_content/51-popup-1-1.png\" alt=\"\">\n          <div class=\"contentLink\" style=\"top: 41px; left: 1040px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('51-popups-1');\"></div>  \n        </div>\n        <div id=\"51-popups-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"51-pop-2-1\" class=\"halfScale 51-popup-2A\" src=\"/120/fr/static/_content/51-popup-2-1.png\" alt=\"\">\n          <img id=\"51-pop-2-2\" class=\"halfScale 51-popup-2\" src=\"/120/fr/static/_content/51-popup-2-2.png\" style=\"opacity:0\" alt=\"\">\n          <div class=\"contentLink\" style=\"top: 798px; left: 600px; width: 125px; height: 48px;\"\n            onclick=\"togglePage51('51-pop-2-1', '51-popup-2');\"></div>\n          <div class=\"contentLink\" style=\"top: 798px; left: 755px; width: 125px; height: 48px;\"\n            onclick=\"togglePage51('51-pop-2-2', '51-popup-2');\"></div>\n          <div class=\"contentLink\" style=\"top: 40px; left: 1040px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('51-popups-2');\"></div>\n        </div>\n      ",
    "mobileHtml": "\n        <h2 id=\"fie-news\">Actualit\xE9s de la FIE</h2>\n        <p><strong>1<br>Ateliers \u201CPower-Up\u2019\u2019 du CIO Athlete365 Career+ </strong></p>\n        <img src=\"/120/fr/static/_content/51-mobile-1.jpg\">\n        <p><strong>Des ateliers Athlete365 Career+ organis\xE9s dans le cadre des Championnats du monde d'escrime juniors et cadets 2022 \xE0 Duba\xEF.</strong></p>\n        <p>Avant le d\xE9but des Championnats du monde d'escrime juniors et cadets 2022 \xE0 Duba\xEF, \xC9mirats Arabes Unis, un atelier \xAB Power Up \xBB a \xE9t\xE9 organis\xE9 dans le cadre du programme Career+ Athlete 365 du CIO pour les tireurs participant au stage d'entra\xEEnement officiel de la FIE. L'atelier, anim\xE9 par Maria Ntanou, triple olympienne et responsable de la communication num\xE9rique de la FIE, a \xE9t\xE9 suivi par 16 tireurs de 16 pays distincts.</p>\n        <p>Au cours de cet atelier d'une demi-journ\xE9e, plusieurs th\xE8mes ont \xE9t\xE9 abord\xE9s, avec par exemple un module sur la mani\xE8re d'identifier ses atouts et ses valeurs. </p>\n        <p>L'atelier a permis d'expliquer que quel que soit le stade de sa carri\xE8re, il \xE9tait important de prendre le temps de r\xE9fl\xE9chir et d'\xE9valuer qui on \xE9tait et ce que l'on souhaitait dans la vie. Il a \xE9galement mis l'accent sur le fait qu'identifier ses \xAB superpouvoirs \xBB, mais \xE9galement ce qui nous motive et nous pousse vraiment, \xE9tait utile dans tous les aspects de sa carri\xE8re et de sa vie.</p>\n        <p>La premi\xE8re session \xE9tait ax\xE9e sur l'auto-r\xE9flexion et sur des activit\xE9s men\xE9es par groupes d'athl\xE8tes pour r\xE9pondre \xE0 des questions telles que : \xAB Qu'est-ce qui est formidable chez moi ? \xBB, \xAB En quoi pourrais-je \xEAtre meilleur ? \xBB et \xAB Qu'est-ce qui est important pour moi ? \xBB \xC0 la fin de la session, les tireurs \xE9taient capables de citer trois de leurs principaux atouts et trois domaines dans lesquels ils pouvaient encore s'am\xE9liorer. </p>\n        <p><strong>2<br>La FIE soutient la Journ\xE9e internationale du sport au service du d\xE9veloppement et de la paix le 6 avril dans le cadre des Championnats du monde d'escrime juniors et cadets \xE0 Duba\xEF</strong></p>\n        <img src=\"/120/fr/static/_content/51-mobile-2.jpg\">\n        <p><strong>Duba\xEF, \xC9mirats Arabes Unis, 6 avril 2022\u2014C'est aujourd'hui la Journ\xE9e internationale du sport au service du d\xE9veloppement et de la paix (IDSDP), un mouvement cr\xE9\xE9 par l'Assembl\xE9e g\xE9n\xE9rale des Nations Unies et soutenu par la FIE.</strong></p>\n        <p>Chaque ann\xE9e, le 6 avril, le monde du sport met en avant le pouvoir unique du sport comme outil pour soutenir les personnes et les communaut\xE9s afin de surmonter l'adversit\xE9 et contribuer de mani\xE8re significative au d\xE9veloppement durable en \xE9tant un moteur essentiel. Il est reconnu que les activit\xE9s sportives ont un impact positif sur la paix et l'harmonie dans la coexistence des communaut\xE9s dans le monde.\n        </p>\n        <p>Lors des Championnats du monde d'escrime juniors et cadets, organis\xE9s du 2 au 10 avril \xE0 Duba\xEF, \xC9mirats Arabes Unis, les athl\xE8tes ont re\xE7u des informations sur l'IDSDP et ont \xE9t\xE9 invit\xE9s \xE0 tenir un carton blanc, le symbole embl\xE9matique de la Journ\xE9e. En r\xE9f\xE9rence aux cartons jaune et rouge dans le monde du sport, le symbole #WhiteCard cr\xE9\xE9 par l'organisation Peace and Sport repr\xE9sente depuis 2014 le pouvoir positif du sport en faveur de la paix et de l'inclusion sociale.</p>\n        <p>De jeunes athl\xE8tes internationaux qui participaient aux Championnats du monde d'escrime juniors et cadets dans les diff\xE9rentes armes (\xE9p\xE9e, fleuret, sabre) et des deux genres ont fait part de leurs r\xE9flexions sur l'initiative du 6 avril :\n        </p>\n        <p>\xAB Le sport est une mani\xE8re de nous lier par quelque chose que nous avons tous en commun. Il y a des milliers de tireurs ici qui mettent de c\xF4t\xE9 leurs diff\xE9rences pour participer \xE0 la comp\xE9tition. Bien s\xFBr, c'est impossible de faire cela sans paix. \xBB</p>\n        <p>Jakob Lars Kristmannson (ISL)</p>\n        <p>\xAB La paix et le sport unifient les gens, m\xEAme s'ils sont en comp\xE9tition. Il y a un haut niveau d'esprit sportif et de compr\xE9hension, c'est donc un super moyen pour r\xE9unir les gens. \xBB</p>\n        <p>Sanojah Gilkes (BAR)</p>\n        <p>\xAB Les sports comme l'escrime r\xE9unissent les gens ; ils se mesurent les uns aux autres mais sont \xE9galement des camarades. En tant que sportif, m\xEAme si vous combattez, vous voulez \xEAtre sur d'\xEAtre en paix lorsque vous n'\xEAtes pas en comp\xE9tition, pouvoir vous rapprocher des autres et \xE9changer avec eux. \xBB</p>\n        <p>Daniella Weng Yan Tang (SGP)</p>\n        <p>D'apr\xE8s l'organisation Peace and Sport : \xAB Par le biais d'un #WhiteCard, nous pouvons tous sensibiliser sur le pouvoir unique du sport en faveur du d\xE9veloppement social et de la paix, et partager une histoire sur la mani\xE8re dont le sport nous a aid\xE9s \xE0 surmonter des difficult\xE9s. \xBB</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg51Anim = new TimelineMax();\n          pg51Anim\n            .fromTo(cOf(\"51-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"51-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        function togglePage51(show, hide) {\n          var show = idOf(show)\n          var hide = cOf(hide)\n          TweenMax.to(hide, 0.01, {opacity: 0});\n          TweenMax.to(show, 0.01, {opacity:1});\n        }\n        function onPageLeave() {\n          pg51Anim.stop();\n          resetNumbers(\"51-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACTUALITÉS  ACTUALITÉS DE LA FIE 2  WWW.FIE.ORG  La FIE soutient la Journée internationale du sport au service du développement et de la paix Voir plus ici.  1  Ateliers “Power-Up’’ du CIO Athlete365 Career+ Voir plus ici.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:jason@jiangfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 76px; right: 352px; width: 235px; height: 19px;\"></div>\n        </a>\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 97px; right: 377px; width: 211px; height: 17px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/52-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 53-title\" style=\"top:41px;left:61px;\" src=\"/120/fr/static/_content/53-title-1.png\">\n\n        <img id=\"53-next\" class=\"halfScale pointer\" style=\"top:719px;right:-184px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/fr/static/_content/arrow-long-navy.png\">\n        \n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div id=\"53-1\" class=\"abs noOverflow 53-div\" style=\"top:299px; left: 65px; height: 520px; width: 810px; display: block;\">\n          <img id=\"53-text-1a\" class=\"halfScale 53-text-1\" style=\"top:0px;left:0px;\"\n            src=\"/120/fr/static/_content/53-text-1-1.png\">\n          <img id=\"53-text-1b\" class=\"halfScale 53-text-1\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/fr/static/_content/53-text-1-2.png\">\n          <div id=\"53-btn-1a\" class=\"abs halfScale pointer 53-btn-1\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-1a', '53-btn-1', '53-text-1a', '53-text-1')\"></div>\n          <div id=\"53-btn-1b\" class=\"abs halfScale pointer 53-btn-1\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-1b', '53-btn-1', '53-text-1b', '53-text-1')\"></div>\n        </div>\n        \n        <div id=\"53-2\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-2a\" class=\"halfScale 53-text-2\" style=\"top:0px;left:0px;\"\n            src=\"/120/fr/static/_content/53-text-2-1.png\">\n          <img id=\"53-text-2b\" class=\"halfScale 53-text-2\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/fr/static/_content/53-text-2-2.png\">\n          <div id=\"53-btn-2a\" class=\"abs halfScale pointer 53-btn-2\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-2a', '53-btn-2', '53-text-2a', '53-text-2')\"></div>\n          <div id=\"53-btn-2b\" class=\"abs halfScale pointer 53-btn-2\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-2b', '53-btn-2', '53-text-2b', '53-text-2')\"></div>\n        </div>\n        \n        <div id=\"53-3\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-3a\" class=\"halfScale 53-text-3\" style=\"top:0px;left:0px;\"\n            src=\"/120/fr/static/_content/53-text-3-1.png\">\n          <img id=\"53-text-3b\" class=\"halfScale 53-text-3\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/fr/static/_content/53-text-3-2.png\">\n          <div id=\"53-btn-3a\" class=\"abs halfScale pointer 53-btn-3\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-3a', '53-btn-3', '53-text-3a', '53-text-3')\"></div>\n          <div id=\"53-btn-3b\" class=\"abs halfScale pointer 53-btn-3\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-3b', '53-btn-3', '53-text-3b', '53-text-3')\"></div>\n        </div>\n        \n        <div id=\"53-4\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-4a\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px;\"\n            src=\"/120/fr/static/_content/53-text-4-1.png\">\n          <img id=\"53-text-4b\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/fr/static/_content/53-text-4-2.png\">\n          <img id=\"53-text-4c\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/fr/static/_content/53-text-4-3.png\">\n          <div id=\"53-btn-4a\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-4a', '53-btn-4', '53-text-4a', '53-text-4')\"></div>\n          <div id=\"53-btn-4b\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-4b', '53-btn-4', '53-text-4b', '53-text-4')\"></div>\n          <div id=\"53-btn-4c\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-4c', '53-btn-4', '53-text-4c', '53-text-4')\"></div>\n        </div>\n        \n        <div id=\"53-5\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-5a\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px;\"\n            src=\"/120/fr/static/_content/53-text-5-1.png\">\n          <img id=\"53-text-5b\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px; opacity:0;;\"\n            src=\"/120/fr/static/_content/53-text-5-2.png\">\n          <img id=\"53-text-5c\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px; opacity:0;;\"\n            src=\"/120/fr/static/_content/53-text-5-3.png\">\n          <div id=\"53-btn-5a\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-5a', '53-btn-5', '53-text-5a', '53-text-5')\"></div>\n          <div id=\"53-btn-5b\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-5b', '53-btn-5', '53-text-5b', '53-text-5')\"></div>\n          <div id=\"53-btn-5c\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-5c', '53-btn-5', '53-text-5c', '53-text-5')\"></div>\n        </div>\n        \n        <div id=\"53-6\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-6a\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px;\"\n            src=\"/120/fr/static/_content/53-text-6-1.png\">\n          <img id=\"53-text-6b\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/fr/static/_content/53-text-6-2.png\">\n          <img id=\"53-text-6c\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/fr/static/_content/53-text-6-3.png\">\n          <div id=\"53-btn-6a\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-6a', '53-btn-6', '53-text-6a', '53-text-6')\"></div>\n          <div id=\"53-btn-6b\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-6b', '53-btn-6', '53-text-6b', '53-text-6')\"></div>\n          <div id=\"53-btn-6c\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-6c', '53-btn-6', '53-text-6c', '53-text-6')\"></div>\n        </div>\n        \n        <img id=\"53-cta-1\" class=\"halfScale pointer 53-btn\" style=\"top:258px;left:869px;transform:scale(0.506,0.52);\"\n          onclick=\"pg53Toggle('53-1', '53-cta-1');\" src=\"/120/fr/static/_content/53-name-1.png\">\n        <img id=\"53-cta-2\" class=\"halfScale pointer 53-btn\" style=\"top:325px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-2', '53-cta-2');\" src=\"/120/fr/static/_content/53-name-2.png\">\n        <img id=\"53-cta-3\" class=\"halfScale pointer 53-btn\" style=\"top:393px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-3', '53-cta-3');\" src=\"/120/fr/static/_content/53-name-3.png\">\n        <img id=\"53-cta-4\" class=\"halfScale pointer 53-btn\" style=\"top:461px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-4', '53-cta-4');\" src=\"/120/fr/static/_content/53-name-4.png\">\n        <img id=\"53-cta-5\" class=\"halfScale pointer 53-btn\" style=\"top:528px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-5', '53-cta-5');\" src=\"/120/fr/static/_content/53-name-5.png\">\n        <img id=\"53-cta-6\" class=\"halfScale pointer 53-btn\" style=\"top:595px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-6', '53-cta-6');\" src=\"/120/fr/static/_content/53-name-6.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"obituaries\">N\xC9CROLOGIES</h2>\n        <p><strong>1<br>Jahangir Safarov (AZE)</strong></p>\n        <img src=\"/120/fr/static/_content/53-mobile-1.png\">\n        <p><strong>LAUSANNE, Suisse, 10 d\xE9cembre 2021\u2014C\u2019est avec une grande tristesse que la FIE a appris le d\xE9c\xE8s de Jahangir Safarov (AZE), le 12 novembre. Jahangir Safarov \xE9tait entra\xEEneur de l\u2019\xE9quipe nationale d\u2019escrime de l\u2019Azerba\xEFdjan, ainsi qu\u2019arbitre national.</strong></p>\n        <p>N\xE9 le 9 mars 1968, c\u2019est \xE0 l\u2019\xE2ge de 10 ans qu\u2019il commen\xE7a l\u2019escrime. Il fut m\xE9daill\xE9 \xE0 de nombreuses reprises dans des comp\xE9titions organis\xE9es en URSS, et participa \xE0 des Championnats du monde et d\u2019Europe. Il fut nomm\xE9 Ma\xEEtre \xE9m\xE9rite du sport de l\u2019URSS en 1985. </p>\n        <p>Il devint entra\xEEneur de l\u2019\xE9quipe nationale d\u2019Azerba\xEFdjan en 2001, et forma plusieurs champions nationaux ainsi que des tireurs m\xE9daill\xE9s dans des comp\xE9titions internationales et r\xE9gionales. Il fut \xE9galement entra\xEEneur en chef de l\u2019\xE9quipe cadette de sabre f\xE9minin. L\u2019une de ses \xE9l\xE8ves, Zarifa Huseynova, a d\xE9croch\xE9 la m\xE9daille de bronze du sabre cadet en individuel lors des Championnats du monde d\u2019escrime juniors et cadets 2021 au Caire. Son fils, Javanshir Safarov, qu\u2019il entra\xEEna \xE9galement, fut m\xE9daill\xE9 d\u2019argent au sabre lors de la Coupe du monde junior de T\xE9h\xE9ran en d\xE9cembre 2013. </p>\n        <p>Au nom de la famille mondiale de l\u2019escrime, la FIE pr\xE9sente ses sinc\xE8res condol\xE9ances \xE0 la famille de M. Jahangir Safarov et \xE0 ses amis, \xE0 la F\xE9d\xE9ration azerba\xEFdjanaise d\u2019escrime et \xE0 la Conf\xE9d\xE9ration europ\xE9enne d\u2019escrime, et tient \xE0 leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>\n        <p><strong>2<br>Alex Orban (USA) </strong></p>\n        <img src=\"/120/fr/static/_content/53-mobile-2.png\">\n        <p><strong>LAUSANNE, Suisse, 9 d\xE9cembre 2021\u2014C\u2019est avec tristesse que la FIE a appris le d\xE9c\xE8s de M. Alex Orban (USA), Olympien \xE0 trois reprises au sabre, le 2 d\xE9cembre \xE0 l\u2019\xE2ge de 82 ans. </strong></p>\n        <p>N\xE9 le 25 ao\xFBt 1939 \xE0 Budapest, Hongrie, Alex Orban a commenc\xE9 l\u2019escrime \xE0 l\u2019\xE2ge de 14 ans. \xC0 16 ans, il fut le plus jeune tireur de l\u2019histoire \xE0 atteindre un haut de classement en Hongrie, ce qui lui valut le surnom d\u2019\xAB \xE9toile montante des \xE9quipes Magyars \xBB. </p>\n        <p>M. Orban d\xE9m\xE9nagea aux \xC9tats-Unis et apr\xE8s trois ann\xE9es de service dans l\u2019US Army, il s\u2019entra\xEEna et reprit les comp\xE9titions d\u2019escrime. Il devint membre de l\u2019\xE9quipe olympique am\xE9ricaine d\u2019escrime et participa aux Jeux Olympiques de 1968 (Mexico), 1972 (Munich) et 1976 (Montr\xE9al). </p>\n        <p>Il fut champion national des \xC9tats-Unis au sabre en 1965, puis de 1969 \xE0 1972, et m\xE9daill\xE9 d\u2019or au sabre individuel aux Jeux panam\xE9ricains de 1971 \xE0 Cali, Colombie. M. Orban a \xE9galement \xE9t\xE9 m\xE9daill\xE9 d\u2019argent au sabre par \xE9quipes aux Jeux panam\xE9ricains de 1971 et 1975 (Mexico). Il fut le premier sabreur am\xE9ricain \xE0 remporter une comp\xE9tition internationale de classe A, en 1968 \xE0 Lodz, Pologne. M. Orban a \xE9t\xE9 intronis\xE9 au Hall of Fame de l\u2019escrime am\xE9ricaine en 1999.</p>\n        <p>Au nom de la famille mondiale de l\u2019escrime, la FIE pr\xE9sente ses sinc\xE8res condol\xE9ances \xE0 la famille de M. Alex Orban et \xE0 ses amis, \xE0 la F\xE9d\xE9ration am\xE9ricaine d\u2019escrime et \xE0 la Conf\xE9d\xE9ration panam\xE9ricaine d\u2019escrime, et tient \xE0 leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>\n        <p><strong>3<br>Ali Youssef Hussain (KUW, MH)</strong></p>\n        <img src=\"/120/fr/static/_content/53-mobile-3.png\">\n        <p><strong>LAUSANNE, Suisse, 30 d\xE9cembre 2021\u2014C\u2019est avec une grande tristesse que la FIE a appris le d\xE9c\xE8s d\u2019Ali Youssef Hussain (KUW), Membre d\u2019honneur et membre du Hall of Fame de la FIE, le 26 d\xE9cembre dernier, \xE0 l\u2019\xE2ge de 83 ans.</strong></p>\n        <p>M. Hussain \xE9tait un ancien membre du Comit\xE9 ex\xE9cutif de la FIE (2001-2008). Il fut nomm\xE9 Membre d\u2019honneur de la FIE par le Congr\xE8s en 2008. Il fut membre de la Commission Promotion de la FIE (nomm\xE9e aujourd\u2019hui Commission Promotion, Communication et Marketing) de 1985 \xE0 2004.</p>\n        <p>En 1977, il fut \xE9lu membre de la Kuwait Amateur Fencing Association, puis devint son pr\xE9sident pendant huit ann\xE9es. Il fut \xE9galement membre de son Conseil d\u2019administration et de son Comit\xE9 technique, ainsi que Responsable Produits de l\u2019organisation. M. Hussain \xE9tait membre du Conseil d\u2019administration du Comit\xE9 National Olympique du Kowe\xEFt, et y a \xE9galement assum\xE9 la fonction de secr\xE9taire-tr\xE9sorier de 1994 \xE0 2014. </p>\n        <p>Il a commenc\xE9 \xE0 pratiquer plusieurs sports d\xE8s son plus jeune \xE2ge, et fut membre du Yarmouk Sports Club d\xE8s 1965, ann\xE9e de sa cr\xE9ation. Il fut membre de son Conseil d\u2019administration pendant 10 ans et y assuma les fonctions de secr\xE9taire g\xE9n\xE9ral et pr\xE9sident.</p>\n        <p>M. Hussain a suivi plusieurs cursus p\xE9dagogiques, notamment une formation olympique universitaire internationale en gestion du sport en 1987. Il a \xE9galement \xE9tudi\xE9 les Sciences du management et m\xE9tiers du sport sous la supervision de la F\xE9d\xE9ration sportive arabe, ce qui lui a permis d\xE8s 1988 de poursuivre sa carri\xE8re dans l\u2019administration sportive. </p>\n        <p>La FIE pr\xE9sente ses sinc\xE8res condol\xE9ances \xE0 la famille et aux amis d\u2019Ali Youssef Hussain, \xE0 la Kuwait Fencing Amateur Association et \xE0 la Conf\xE9d\xE9ration asiatique d\u2019escrime, et tient \xE0 leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>\n        <p></p>\n        <p><strong>4<br>Olga Orban-Szabov (ROU)</strong></p>\n        <img src=\"/120/fr/static/_content/53-mobile-4.png\">\n        <p><strong>LAUSANNE, Suisse, 17 janvier 2022\u2014C\u2019est avec une grande tristesse que la FIE a appris le d\xE9c\xE8s d\u2019Olga Orban-Szabo (ROM), multiple m\xE9daill\xE9e olympique et championne du monde, et membre du Hall of Fame de la FIE, le 5 janvier dernier. </strong></p>\n        <p>N\xE9e le 9 octobre 1938 \xE0 Cluj, Mme Szabo fut la premi\xE8re m\xE9daill\xE9e olympique et championne du monde de la Roumanie. Elle participa \xE0 cinq Jeux Olympiques (Melbourne 1956, Rome 1960, Tokyo 1964, Mexico 1968 et Munich 1972). Elle remporta sa premi\xE8re m\xE9daille olympique, une m\xE9daille d\u2019argent au fleuret individuel, \xE0 Melbourne, puis une m\xE9daille de bronze au fleuret par \xE9quipes aux Jeux de Mexico et de Munich. \n        </p>\n        <p>Elle fut sacr\xE9e championne du monde de fleuret individuel aux Championnats du monde de Buenos Aires en 1962. Avec l\u2019\xE9quipe roumaine de fleuret f\xE9minin, aux c\xF4t\xE9s de Maria Vicol, Ileana Gyulai, Ecaterina Stahl et Ana Pascu, elle remporta une m\xE9daille d\u2019or aux Championnats du monde de La Havane 1969, une autre premi\xE8re dans l\u2019histoire de son pays. \n        </p>\n        <p>Entre 1961 et 1970, Mme Orban-Szabo remporta au total 11 m\xE9dailles au fleuret aux Jeux Olympiques et aux Championnats du monde (trois aux J.O. et huit aux Championnats du monde). Avant cela, elle fut vice-championne du monde junior en 1959. Elle remporta \xE9galement trois m\xE9dailles aux Universiades : une m\xE9daille d\u2019argent en individuel et une m\xE9daille d\u2019or par \xE9quipes en 1961, et une m\xE9daille d\u2019argent par \xE9quipes en 1965.\n        </p>\n        <p>En tant que membre du club de l\u2019arm\xE9e \xAB Steaua Bucarest \xBB, elle remporta sept fois le championnat national roumain, et re\xE7ut le titre national de \xAB Ma\xEEtre \xE9m\xE9rite du sport \xBB ainsi que de nombreux ordres et titres roumains. Elle \xE9tait dipl\xF4m\xE9e de l\u2019Universit\xE9 Babes-Bolyai \xE0 Cluj-Napoca, et \xE9galement Ma\xEEtre d\u2019armes. Suite \xE0 sa retraite sportive en 1972, elle travailla comme entra\xEEneur d\u2019escrime pour les jeunes dans son club \xE0 Bucarest.</p>\n        <p>\xAB C\u2019\xE9tait une Lady prestigieuse de l\u2019\xE9quipe d\u2019escrime roumaine, \xBB a d\xE9clar\xE9 Marius Florea, pr\xE9sident de la f\xE9d\xE9ration roumaine. \xAB La F\xE9d\xE9ration roumaine d\u2019escrime aimerait exprimer sa profonde reconnaissance et sa gratitude \xE0 Mme Olga Orban-Szabo pour sa contribution \xE0 la cr\xE9ation de la famille roumaine de l\u2019escrime. \xBB </p>\n        <p>La FIE pr\xE9sente ses sinc\xE8res condol\xE9ances \xE0 la famille et aux amis d\u2019Olga Orban-Szabo, \xE0 la F\xE9d\xE9ration roumaine d\u2019escrime et \xE0 la Conf\xE9d\xE9ration europ\xE9enne d\u2019escrime, et tient \xE0 leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>\n        <p><strong>5<br>Jose Valarinho (POR)</strong></p>\n        <img src=\"/120/fr/static/_content/53-mobile-5.png\">\n        <p><strong>LAUSANNE, Suisse, 4 avril 2022\u2014C\u2019est avec une grande tristesse que la FIE a appris le d\xE9c\xE8s de M. Jos\xE9 Valarinho (POR), Membre du Hall of Fame de la FIE, le 30 mars 2022 \xE0 l\u2019\xE2ge de 87 ans. Il fut membre du Comit\xE9 disciplinaire de la FIE de 1996 \xE0 2004. </strong></p>\n        <p>Il fut trois fois r\xE9compens\xE9 d\u2019une m\xE9daille d\u2019or sp\xE9ciale de la FIE pour ses travaux universitaires sur l\u2019escrime et pour l\u2019organisation du Congr\xE8s de la FIE 1988 \xE0 Mad\xE8re et des Championnats du monde 2002 \xE0 Lisbonne. Il re\xE7ut \xE9galement l\u2019Ordre Olympique du Comit\xE9 olympique portugais, ainsi que la M\xE9daille du m\xE9rite sportif, d\xE9cern\xE9 par le gouvernement portugais. </p>\n        <p>M. Valarinho fut pr\xE9sident de la F\xE9d\xE9ration portugaise d\u2019escrime pendant deux mandats \xE0 partir de 1992. Il rejoignit l\u2019organisation en 1969 en tant que pr\xE9sident de la Commission technique, et il eut pendant plusieurs d\xE9cennies un impact consid\xE9rable sur la croissance et le d\xE9veloppement de l\u2019escrime au Portugal. Il participa au \xAB Plan pour le d\xE9veloppement du sport \xBB avec un programme sp\xE9cial intitul\xE9 \xAB 500 Foils \xBB (500 fleurets), et \u0153uvra pour que le Portugal devienne plus actif sur la sc\xE8ne de l\u2019escrime internationale. </p>\n        <p>M. Valarinho participa \xE0 l\u2019organisation des premiers Championnats d\u2019Europe \xE0 Lisbonne en 1983, et \xE0 celle de plusieurs autres comp\xE9titions continentales et internationales accueillies au Portugal au cours des ann\xE9es 80 et 90. Son souhait de voir le Portugal jouer un r\xF4le actif sur la sc\xE8ne de l\u2019escrime mondiale fut pleinement r\xE9alis\xE9 lorsque l\u2019\xE9quipe de fleuret masculin de son pays remporta la m\xE9daille d\u2019or des Championnats d\u2019Europe 2000 \xE0  Mad\xE8re. Apr\xE8s son d\xE9part de la pr\xE9sidence, il organisa avec succ\xE8s les Championnats du monde d\u2019escrime 2002 \xE0 Lisbonne. </p>\n        <p>Apr\xE8s avoir suivi un enseignement militaire portugais traditionnel, M. Valarinho devint Officier de l\u2019arm\xE9e. C\u2019est pendant sa scolarit\xE9 qu\u2019il s\u2019essaya \xE0 l\u2019escrime pour la premi\xE8re fois, et devint \xE9galement un cavalier talentueux. Il fut dipl\xF4m\xE9 avec mention en tant que \xAB ma\xEEtre \xBB au Centre sportif militaire de Mafra, o\xF9 il tirait en comp\xE9tition, et participa aux Universiades de 1959 en tant que membre de l\u2019\xE9quipe de sabre masculin. Apr\xE8s sa scolarit\xE9, il devint Ma\xEEtre d\u2019armes et se sp\xE9cialisa dans le recrutement et le d\xE9veloppement de jeunes tireurs. </p>\n        <p>Il \xE9crivit deux livres sur l\u2019histoire de l\u2019escrime portugaise, et \xE9tait en train de r\xE9diger une troisi\xE8me \xE9dition. </p>\n        <p>\xAB Ce fut un tireur jusqu\u2019\xE0 son dernier souffle \xBB, a d\xE9clar\xE9 son fils, Frederico Valarinho, membre de la F\xE9d\xE9ration portugaise d\u2019escrime depuis 2006. </p>\n        <p>La FIE pr\xE9sente ses sinc\xE8res condol\xE9ances \xE0 la famille et aux amis de Jos\xE9 Valarinho, \xE0 la F\xE9d\xE9ration portugaise d\u2019escrime et \xE0 la Conf\xE9d\xE9ration europ\xE9enne d\u2019escrime, et tient \xE0 leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>\n        <p> <strong>6<br>Ana Pascu (ROU, MH)</strong></p>\n        <img src=\"/120/fr/static/_content/53-mobile-6.png\">\n        <p><strong>LAUSANNE, Suisse, 9 avril 2022\u2014C\u2019est avec une immense tristesse que la FIE a appris le d\xE9c\xE8s \xE0 Bucarest, le 06 avril 2022, de Mme Ana Pascu (ROU), Membre d\u2019honneur et membre du Hall of Fame de la FIE. Elle \xE9tait n\xE9e le 22 septembre 1944. </strong> </p>\n        <p>\xC9lue en 2000, Mme Pascu \xE9tait membre du Comit\xE9 ex\xE9cutif de la FIE, et fut vice-pr\xE9sidente de 2004 \xE0 2021. Avant cela, elle fut membre de la Commission des R\xE8glements de la FIE de 1984 \xE0 1988, et membre de la Commission de l\u2019arbitrage de la FIE de 1988 \xE0 1996. Elle fut \xE9galement arbitre internationale de la FIE au fleuret et \xE0 l\u2019\xE9p\xE9e. </p>\n        <p>Elle d\xE9tient le record du nombre de mandats effectu\xE9s par un pr\xE9sident de la F\xE9d\xE9ration roumaine d\u2019escrime. De 1982 \xE0 2013, Mme Pascu a dirig\xE9 la F\xE9d\xE9ration, contribuant au succ\xE8s sportif des tireurs roumains qui ont remport\xE9 134 m\xE9dailles sous sa pr\xE9sidence : neuf aux Jeux olympiques, 57 aux Championnats du monde et 68 aux Championnats d\u2019Europe. Suite \xE0 se retraite en tant que pr\xE9sidente, elle a \xE9t\xE9 nomm\xE9e pr\xE9sidente d\u2019honneur de la F\xE9d\xE9ration roumaine d\u2019escrime. Elle fut \xE9galement vice-pr\xE9sidente du Comit\xE9 olympique et sportif roumain. </p>\n        <p>En tant qu\u2019athl\xE8te, Mme Pascu participa cinq fois aux Jeux Olympiques au fleuret. Au fleuret par \xE9quipes, elle remporta une m\xE9daille de bronze aux Jeux Olympiques de 1968 et 1972, et une m\xE9daille d\u2019or aux Championnats du monde de La Havane 1969. Au fleuret individuel, elle fut sacr\xE9e championne du monde junior en 1963 et d\xE9crocha \xE9galement la m\xE9daille de bronze aux Championnats du monde 1971. En tant que membre de l\u2019\xE9quipe roumaine de fleuret f\xE9minin, elle remporta la m\xE9daille d\u2019argent de fleuret par \xE9quipes aux Championnats du monde 1970, et la m\xE9daille de bronze aux Championnats du monde 1961, 1967, 1971, 1973, 1974 et 1975. En 1961 et 1965, son \xE9quipe remporta l\u2019or et l\u2019argent, respectivement, des Jeux mondiaux universitaires (\xAB Universiade \xBB). </p>\n        <p>Mme Pascu fut \xE9galement entra\xEEneur d\u2019escrime et professeur d\u2019\xE9ducation physique jusqu\u2019en 1982, apr\xE8s avoir obtenu son doctorat en \xE9ducation physique et sportive. La th\xE8se de son doctorat \xE9tait intitul\xE9e \xAB The Strategy for Enhancing Sports Preparation in Competitions \xBB (Strat\xE9gie pour am\xE9liorer la pr\xE9paration sportive en comp\xE9tition). Elle re\xE7ut \xE9galement un \xAB Doctor Honoris Causa \xBB de l\u2019Universit\xE9 Vasile Goldis en Roumanie. Elle est l\u2019auteur de nombreuses publications scientifiques et sportives, et a re\xE7u de nombreux titres et d\xE9corations, notamment l\u2019Ordre national du m\xE9rite au rang d\u2019Officier et Chevalier. Mme Pascu a consacr\xE9 sa vie enti\xE8re \xE0 l\u2019escrime, aux tireurs, \xE0 l\u2019escrime roumaine et \xE0 la FIE, et les nombreuses succ\xE8s qui en ont d\xE9coul\xE9 t\xE9moignent de son incroyable talent et de sa passion pour notre sport. Emmanuel Katsiadakis, pr\xE9sident int\xE9rimaire de la FIE, a dit d\u2019elle : \xAB Elle aidait, soutenait et motivait sans rel\xE2che, avec g\xE9n\xE9rosit\xE9 et avec une gentillesse infinie, tout ceux qui demandaient son aide et des conseils. C\u2019\xE9tait une mentor extraordinaire et un mod\xE8le pour les athl\xE8tes, les officiels et les dirigeants de l\u2019escrime, ainsi que pour les filles et les femmes dans le sport. \xBB La FIE pr\xE9sente ses sinc\xE8res condol\xE9ances \xE0 la famille de Mme Pascu et \xE0 ses amis, \xE0 la F\xE9d\xE9ration roumaine d\u2019escrime et \xE0 la Conf\xE9d\xE9ration europ\xE9enne d\u2019escrime, et tient \xE0 leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim\n            .to(idOf(\"53-1\"), 0.3,{display: 'block'}, 0)\n            .fromTo(cOf(\"53-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"53-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function pg53Toggle(id, btn) {\n          var ele = idOf(id)\n          var but = idOf(btn)\n          TweenMax.to(cOf(\"53-div\"), 0.01, {display: 'none'});\n          TweenMax.to(cOf(\"53-btn\"), 0.01, {opacity: 0});\n          TweenMax.to(ele, 0.1, {display: 'block'});\n          TweenMax.to(but, 0.1, {opacity: 1});\n        }\n        \n        function togglePage(id, klass, text, texttwo) {\n          var ele = idOf(id)\n          var but = cOf(klass)\n          var txt = idOf(text)\n          var txt2 = cOf(texttwo)\n          TweenMax.to(but, 0.01, {opacity: 0});\n          TweenMax.to(txt2, 0.01, {opacity: 0});\n          TweenMax.to(ele, 0.01, {opacity:1});\n          TweenMax.to(txt, 0.01, {opacity:1});\n        }\n        \n        function onPageLeave(){\n          pg53Toggle('53-text-1', '53-cta-1');\n          togglePage('53-btn-1', '53-btn-2', '53-text-1', '53-text-1');\n          pg53Anim.stop();\n          resetNumbers(\"53-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "NÉCROLO GIE  NÉCROLOGIES JAHANGIR SAFAROV  JAHANGIR SAFAROV (AZE) des compétitions organisées en URSS, et participa à des Championnats du monde et d’Europe. Il fut nommé Maître émérite du sport de l’URSS en 1985.  LAUSANNE, Suisse, 10 décembre 2021—C’est avec une grande tristesse que la FIE a appris le décès de Jahangir Safarov (AZE), le 12 novembre. Jahangir Safarov était entraîneur de l’équipe nationale d’escrime de l’Azerbaïdjan, ainsi qu’arbitre national. Né le 9 mars 1968, c’est à l’âge de 10 ans qu’il commença l’escrime. Il fut médaillé à de nombreuses reprises dans  Il devint entraîneur de l’équipe nationale d’Azerbaïdjan en 2001, et forma plusieurs champions nationaux ainsi que des tireurs médaillés dans des compétitions internationales et régionales. Il fut également entraîneur en chef de l’équipe cadette de sabre féminin. L’une de ses élèves, Zarifa Huseynova, a décroché la médaille de  ALEX ORBAN  ALI YOUSSEF HUSSAIN  OLGA ORBAN-SZABO  JOSE VALARINHO  ANA PASCU  s Cliquez ici  1  2  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 186px; right: 599px; width: 228px; height: 38px;\"></div>\n        </a>\n        <a href=\"mailto:sales@gfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 186px; right: 340px; width: 236px; height: 38px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <img src=\"/120/fr/static/_content/54-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n        \n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) { \n          return e.className = 'addContentLinkThree'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": [{
    title: "Escrime XXI N⁰. 120",
    link: "Escrime XXI N⁰. 120",
    cssClass: "cover mobile-p1",
    hideInMenu: false,
    pageLinks: [{
      index: 0,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 2,
      subIndex: 0
    }]
  }, {
    title: "COMITÉ EXÉCUTIF DE LA FIE",
    link: "COMITÉ EXÉCUTIF DE LA FIE",
    cssClass: "blue",
    hideInMenu: false,
    pageLinks: [{
      index: 4,
      subIndex: 0
    }]
  }, {
    title: "ÉDITORIAL",
    link: "ÉDITORIAL",
    cssClass: "darkblue",
    hideInMenu: false,
    pageLinks: [{
      index: 5,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 6,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Tashkent",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 7,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Orleans",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 9,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 12,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Tallinn",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 13,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Bern",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 16,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 18,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | St Maur",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 19,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Paris",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 21,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 23,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Poznan",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 24,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Tbilisi",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 26,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 29,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Plovdiv",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 30,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Doha",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 32,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Budapest",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 34,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 37,
      subIndex: 0
    }]
  }, {
    title: "SPORT",
    link: "SPORT | Dubai",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 38,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 43,
      subIndex: 0
    }]
  }, {
    title: "FIE",
    link: "ACTUALITÉS DE LA FIE",
    cssClass: "pink",
    hideInMenu: false,
    pageLinks: [{
      index: 44,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 45,
      subIndex: 0
    }]
  }, {
    title: "ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONALES",
    link: "ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONALES | Togo",
    cssClass: "green",
    hideInMenu: false,
    pageLinks: [{
      index: 46,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 49,
      subIndex: 0
    }]
  }, {
    title: "ACTUALITÉS",
    link: "ACTUALITÉS",
    cssClass: "orange",
    hideInMenu: false,
    pageLinks: [{
      index: 50,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 51,
      subIndex: 0
    }]
  }, {
    title: "NÉCROLOGIES",
    link: "NÉCROLOGIES",
    cssClass: "grey",
    hideInMenu: false,
    pageLinks: [{
      index: 52,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 53,
      subIndex: 0
    }]
  }],
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-199016370-50',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6ba6703ab1d460d81e6e.js